import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { baseURL } from "../../../globalUtils/axiosConfig";
import useApiQueueLoading from "../../../globalUtils/useApiQueueLoading";
import moment from "moment";
import { CloseCircleFilled } from "@ant-design/icons";
import "./index.less"; // Import the CSS file
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  Col,
  Row,
  Space,
  Tag,
  DatePicker,
  message,
  Select,
  Dropdown,
  Menu,
  Checkbox,
  Spin,
} from "antd";
import { PlusOutlined, CheckCircleFilled, ArrowRightOutlined, DownOutlined } from "@ant-design/icons";
import { CircleOutlined } from "@ant-design/icons"; // Import CircleOutlined icon
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "../../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/delete-icon.svg";
import { ReactComponent as SaveIcon } from "../../../assets/save-icon.svg";
import { ReactComponent as AttachIcon } from "../../../assets/attach.svg";
import { ReactComponent as FilterIcon } from "../../../assets/filter.svg";
import ShippingIcon from "../../../assets/shipping_icon.png";
import InProgressIcon from "../../../assets/in_progress.png";
import CompletedIcon from "../../../assets/completed.png";
import ReceivedIcon from "../../../assets/received_icon.png";
import OnHoldIcon from "../../../assets/476dab3b4f69c5886bdab2c64c134f28_e20f00.svg";
import { ReactComponent as CrossIcon } from "../../../assets/crossIcon.svg";
import { ReactComponent as BatchUpdateIcon } from "../../../assets/patch-update.svg";
import {
  createMaterialControl,
  updateMaterialControl,
  deleteMaterialControl,
  fetchProjectActivities,
  fetchMaterialControl,
  updateProjectActivity,
  updateProjectIsAddIsUpdate,
  fetchProjectBatchUpdate,
} from "../redux/actions";
import { RESET_OPEN_MAIN_FORM } from "../redux/constants";
import SpinnerComponent from "../../../components/spinner";
import _ from "lodash";
import CustomPagination from "../../../components/customPagination/CustomPagination";
import NonEditRowAttach from "./nonEditRowAttachView";
import CustomCalendar from "../../../components/calendar";
import AMultiSelect from "../../../components/AMultiSelect";
import ExpandedRow from "./expandedRow";
import EditableCell from "./editableCell";
import Revisions from "./revisions";
import Distribution from "./distributionTable";
import ExportDoc from "./export";
import ImportDoc from "./import";
import DeliveryNote from "./deliveryNote";
import AddToDeliveryNotePopup from "./deliveryNote/AddToDeliveryNotePopup";
import AddToSignedDeliveryNotePopup from "./deliveryNote/AddToSignedDeliveryNotePopup";
import FilterAndBatchUpdate from "./filterAndBatchUpdate";
import { handleDueDate } from "../../../globalUtils/handleDueDates";
import UseDocControlPermissions from "../permissions/useDocControlPermissions";
import UseRevisionsPermissions from "../permissions/useRevisionsPermissions";
import UseDistributionPermissions from "../permissions/useDistributionPermissions";
import Tooltip from "../../../components/tooltip-Custom";
import { useNavigate, useLocation } from "react-router-dom";
import SingleSelector from "../../../components/singleSelector";
import { attachOptions } from "../utils";
import AddToGrvPopup from "./deliveryNote/AddToGrvPopup";

const DistributionTable = ({
  materialTypeCheckList,
  setMaterialTypeCheckList,
  materialTypeOptions,
  statusCheckList,
  setStatusCheckList,
  statusOptions,
  project_id,
  setSearchResultIds,
}) => {
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState("");
  const [viewMode, setViewMode] = useState("");
  const [sortedInfo, setSortedInfo] = useState(null);
  const [editingLoading, setEditingLoading] = useState(false);
  const [currentUpdateObj, setCurrentUpdateObj] = useState({});
  const [form] = Form.useForm();
  const [fieldsFormRef] = Form.useForm();
  const dispatch = useDispatch();
  const [page, setPage] = useState(() => 1);
  const [resultPerPage, setResultPerPage] = useState(() => 10);
  const [req, setReq] = useState(false);
  const [defaultPageOneReq, setDefaultPageOneReq] = useState(false);
  const [images, setImages] = useState([]);
  // images contains all attachments of item
  const [attachPopupVisible, setAttachPopupVisible] = useState(false);
  const [search, setSearch] = useState({});
  const [date, setDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [deleteDocId, setDeleteDocId] = useState();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [fields, setFields] = useState([]);
  const [datePickerOpened, setDatePickerOpened] = useState(false);
  const [isRevisionUpdateCase, setIsRevisionUpdateCase] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState({});
  const [showBatch, setShowBatch] = useState(false);
  const navigate = useNavigate();
  const { allTemplates } = useSelector((state) => state.materialTemplatesReducer);
  const { user_projects } = useSelector((state) => state.userManagerReducer);
  const location = useLocation();
  const [fetchByParams, setFetchByParams] = useState(true);
  const [docNumber, setDocNumber] = useState("");
  const [revisionRecord, setRevisionRecord] = useState({});
  // State for tracking selected items for delivery note
  const [selectedItems, setSelectedItems] = useState({});
  const [selectedItemsCount, setSelectedItemsCount] = useState(0);
  const [selectedDeliveryNoteType, setSelectedDeliveryNoteType] = useState(null);
  const [isDeliveryNotePopupVisible, setIsDeliveryNotePopupVisible] = useState(false);
  const [isSignedDeliveryNotePopupVisible, setIsSignedDeliveryNotePopupVisible] = useState(false);
  const [plusButtonClicked, setPlusButtonClicked] = useState({});
  const [selectedType, setSelectedType] = useState(null);
  const [isGrvPopupVisible, setIsGrvPopupVisible] = useState(false);
  
  // Function to find the last active step index in progressSteps
  const findLastActiveStepIndex = (progressSteps) => {
    if (!progressSteps || !progressSteps.length) return -1;
    
    let lastActiveIndex = -1;
    for (let i = progressSteps.length - 1; i >= 0; i--) {
      if (progressSteps[i] && (progressSteps[i].status === 'in_progress' || progressSteps[i].status === 'completed' || progressSteps[i].status === 'received')) {
        lastActiveIndex = i;
        break;
      }
    }
    return lastActiveIndex;
  };
  
  // Function to render tracking stage status with icons and dates
  const renderTrackingStageStatus = (stage, record, isLastActiveStep, stageType) => {
    // Handle case where record is On Hold but no progress stages exist
    if (!stage && record && record.status === 'On Hold') {
      // Only show On Hold icon for Fabrication stage when no progress steps exist
      if (stageType === 'Fabrication') {
        return (
          <div className="tracking-status" style={{ color: '#e20f00' }}>
            <img src={OnHoldIcon} alt="On Hold" style={{ width: '22px', height: '20px' }} />
            <div>{moment().format('D MMM YY')}</div>
          </div>
        );
      }
      return null;
    }
    
    if (!stage) return null;
    
    const { status } = stage;
    
    // Check if the record status is 'On Hold' and this is the last active step
    if (record && record.status === 'On Hold' && isLastActiveStep) {
      // Use the date from the step or current date if not available
      const onHoldAt = stage.completedAt || stage.receivedAt ? 
        moment(stage.completedAt || stage.receivedAt).format('D MMM YY') : 
        moment().format('D MMM YY');
      
      return (
        <div className="tracking-status" style={{ color: '#e20f00' }}>
          <img src={OnHoldIcon} alt="On Hold" style={{ width: '22px', height: '20px' }} />
          <div>{onHoldAt}</div>
        </div>
      );
    }
    
    if (status === 'received') {
      const receivedDate = stage.receivedAt ? moment(stage.receivedAt).format('D MMM YY') : '';
      return (
        <div className="tracking-status received">
          <img src={ReceivedIcon} alt="Received" style={{ width: '22px', height: '20px' }} />
          <div>{receivedDate}</div>
        </div>
      );
    }
    
    if (status === 'in_progress') {
      const inProgressDate = stage.completedAt ? moment(stage.completedAt).format('D MMM YY') : '';
      return (
        <div className="tracking-status in-progress">
          <img src={InProgressIcon} alt="In Progress" style={{ width: '22px', height: '20px' }} />
          <div>{inProgressDate}</div>
        </div>
      );
    }
    
    if (status === 'completed') {
      const completedDate = stage.completedAt ? moment(stage.completedAt).format('D MMM YY') : '';
      return (
        <div className="tracking-status completed">
          <img src={CompletedIcon} alt="Completed" style={{ width: '22px', height: '20px' }} />
          <div>{completedDate}</div>
        </div>
      );
    }
    
    return status;
  };
  
  // Handler function for tracking stage status updates from ExpandedRow
  const handleTrackingStageStatusUpdate = (updateData) => {
    const { recordId, stepIndex, type, status, statusDate } = updateData;
    
    // Find the record in the data array
    const updatedData = data.map(item => {
      if (item.id === recordId) {
        // Create a deep copy of the item
        const updatedItem = { ...item };
        
        // Initialize progressSteps array if it doesn't exist
        if (!updatedItem.progressSteps) {
          updatedItem.progressSteps = [];
        }
        
        // Ensure the progressSteps array has enough elements
        while (updatedItem.progressSteps.length <= stepIndex) {
          updatedItem.progressSteps.push({});
        }
        
        // Update the specific progress step
        updatedItem.progressSteps[stepIndex] = {
          ...updatedItem.progressSteps[stepIndex],
          status,
          type,
          receivedAt: status === 'received' ? statusDate : updatedItem.progressSteps[stepIndex].receivedAt,
          completedAt: (status === 'completed' || status === 'in_progress') ? statusDate : updatedItem.progressSteps[stepIndex].completedAt
        };
        
        return updatedItem;
      }
      return item;
    });
    
    // Update the data state with the modified record
    setData(updatedData);
    
    console.log(`Updated tracking stage status for record ${recordId}, step ${stepIndex} (${type}): ${status}`);
  };

  const [attachSearch, setAttachSearch] = useState(null);
  const [addType, setAddType] = useState("Material");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [mcPermissions, setMcPermissions] = useState([]);

  const onPermissionError = () => {
    navigate("/profile");
    return message.error(
      "You don't have the permission to view Document Control. Please contact system admin."
    );
  };

  useEffect(() => {
    const newPermissions = user_projects?.find((el) => el?.projectId === parseInt(project_id));
    setMcPermissions(newPermissions?.permissions);
  }, [user_projects]);



  useEffect(() => {
    if (location?.state?.document_number?.length > 0) {
      const { document_number } = location?.state;
      if (docNumber === document_number) {
        return;
      } else {
        setFetchByParams(true);
      }
      setData([]);
      if (fetchByParams) {
        setDocNumber(document_number);
        setTimeout(() => {
          setData([]);
          setSearch((prev) => ({ ...prev, document_number }));
          debouncedDefaultPageOneCallApi();
          setFetchByParams(false);
        }, 100);
      }
    }
  }, [location, docNumber]);

  useEffect(() => {
    if (
      page &&
      resultPerPage &&
      page > 0 &&
      resultPerPage > 0 &&
      !fetchByParams
    ) {
      console.log('Fetching material control with search params:', search);
      dispatch(
        fetchMaterialControl({
          page: page,
          perPage: resultPerPage,
          search,
          sort: sortedInfo?.order && sortedInfo?.columnKey,
          order: sortedInfo?.order
            ? sortedInfo?.order === "ascend"
              ? "asc"
              : "desc"
            : null,
          projectId: project_id,
          onPermissionError,
        })
      );
      dispatch(
        fetchProjectActivities({
          page,
          perPage: resultPerPage,
          search,
          project_id,
          ...filter,
        })
      );
    }
  }, [req]);

  useEffect(() => {
    setFilter({});
    setSearch({});
    setFields([]);
    setExpandedRowKeys([]);
    setSortedInfo(null);

    // Reset all local search filter states
    setSelectedAreas([]);
    setFabricationStatusFilter([]);
    setQcReleaseStatusFilter([]);
    setCorrosionProtectionStatusFilter([]);
    setDeliveryToSiteStatusFilter([]);
    setSiteReceiptStatusFilter([]);
    setPriorityStatusFilter([]);
    setMaterialTypeStatusFilter([]);
    setAttachSearch(null);

    const isRevisionOperation = window.sessionStorage.getItem('isRevisionOperation');
    const persistedPage = window.sessionStorage.getItem('persistedPage');
    let currentPage = 1;

    if (isRevisionOperation && persistedPage) {
      currentPage = parseInt(persistedPage);
      setPage(currentPage);
    } else {
      setPage(1);
    }

    // Fetch data for the new project without any filters
    dispatch(
      fetchMaterialControl({
        page: currentPage,
        perPage: resultPerPage,
        projectId: project_id,
        onPermissionError,
      })
    );

    dispatch(
      fetchProjectActivities({
        page: currentPage,
        perPage: resultPerPage,
        project_id,
      })
    );

  }, [project_id])

  useEffect(() => {
    if (project_id) {
      const isRevisionOperation = window.sessionStorage.getItem('isRevisionOperation');
      const persistedPage = window.sessionStorage.getItem('persistedPage');
      let currentPage = 1;

      if (isRevisionOperation && persistedPage) {
        currentPage = parseInt(persistedPage);
        setPage(currentPage);
      } else {
        setPage(1);
      }

      dispatch(
        fetchMaterialControl({
          page: currentPage,
          perPage: resultPerPage,
          search,
          orderBy: sortedInfo?.order && sortedInfo?.columnKey,
          orderDirection: sortedInfo?.order
            ? sortedInfo?.order === "ascend"
              ? "asc"
              : "desc"
            : null,
          ...filter,
          projectId: project_id,
          onPermissionError,
        })
      );

      dispatch(
        fetchProjectActivities({
          page: currentPage,
          perPage: resultPerPage,
          search,
          project_id,
          ...filter,
        })
      );

      if (!isRevisionOperation) {
        setPage(1);
      }
    }
  }, [defaultPageOneReq]);

  useEffect(() => {
    debouncedCallApi();
  }, [sortedInfo]);

  // Effect to handle resultPerPage changes
  useEffect(() => {
    if (resultPerPage > 0) {
      // Reset to page 1 when resultPerPage changes
      setPage(1);
      debouncedDefaultPageOneCallApi();
    }
  }, [resultPerPage]);

  // Effect to handle page changes
  useEffect(() => {
    if (page > 0) {
      // Directly fetch data when page changes to ensure all records are fetched
      dispatch(
        fetchMaterialControl({
          page: page,
          perPage: resultPerPage,
          search,
          sort: sortedInfo?.order && sortedInfo?.columnKey,
          order: sortedInfo?.order
            ? sortedInfo?.order === "ascend"
              ? "asc"
              : "desc"
            : null,
          projectId: project_id,
          onPermissionError,
        })
      );
    }
  }, [page]);

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 1000)
  );

  const [debouncedDefaultPageOneCallApi] = useState(() =>
    _.debounce(() => setDefaultPageOneReq((prev) => !prev), 1000)
  );

  const isEditing = (record) => {
    // Check if this record is currently being edited
    // If we're in loading state for this record, we still want to show the form fields
    // but disable editing
    return record.key === editingKey || record.id === editingKey;
  };

  const [suppressTableLoader, setSuppressTableLoader] = useState(false);
  const { activate: activateQueueLoader } = useApiQueueLoading("api-queue-overlay", setSuppressTableLoader);

  const { user } = useSelector((state) => state.authReducer);
  const {
    allMaterialControl,
    totalRecords,
    fetchDocsLoading,
    updateLoading,
    fetchUtilsLoading,
    isAddImsDoc,
    isUpdateImsDoc,
    deletingLoading,
    currentMaterialControl,
    openMainForm,
    mainFormType,
    mainFormRecord,
    closeMainForm
  } = useSelector((state) => state.projectReducer);

  // Combine all loading states for the overlay
  const isAnyLoading = updateLoading || fetchDocsLoading;
  
  const materialControlState = useSelector((state) => state.materialControlReducer) || {};
  const {
    materialControl = [],
    materialControlLoading = false,
    materialControlError = null,
    materialControlTotalRecords = 0,
  } = materialControlState;

  const materialTypesState = useSelector((state) => state.materialTypesReducer) || {};
  const {
    allMaterialTypes = [],
    allBoltTypes = [],
  } = materialTypesState;

  // Create material type options from API data with names as values
  const dynamicMaterialTypeOptions = useMemo(() => {
    const options = [];
    
    // Add Bolts option first
    options.push({ value: "Bolts", label: "Bolts" });
    
    // Add material types from API using materialType names as values
    if (allMaterialTypes && Array.isArray(allMaterialTypes)) {
      allMaterialTypes.forEach(materialType => {
        if (materialType.materialType) {
          options.push({
            value: materialType.materialType,
            label: materialType.materialType
          });
        }
      });
    }
    
    return options;
  }, [allMaterialTypes]);

  // Listen for changes in currentMaterialControl and refresh the expanded row
  useEffect(() => {
    if (currentMaterialControl) {
      // Merge updated data into the existing data array in-place
      // This preserves the ExpandedRow component and its local state
      setData(prevData => prevData.map(item =>
        item.id === currentMaterialControl.id
          ? { ...item, ...currentMaterialControl }
          : item
      ));
    }
  }, [currentMaterialControl]);

  // Listen for openMainForm state changes from Redux
  useEffect(() => {
    if (openMainForm && mainFormType) {
      // Make sure isRevisionUpdateCase is false to ensure fields are editable
      setIsRevisionUpdateCase(false);
      setRevisionRecord(mainFormRecord);
      // Call handleTypeSelect with the type from Redux and use the record data if available
      // handleTypeSelect(mainFormType, mainFormRecord);
      edit(mainFormRecord, openMainForm);
      // Reset the state to prevent repeated triggering
      dispatch({ type: RESET_OPEN_MAIN_FORM });
    }

    if (closeMainForm) {

      const isRevisionOperation = mainFormRecord && mainFormRecord.revision;
      
      if (isRevisionOperation) {
        // setEditingKey("");
        // setExpandedRowKeys([]);
        // Only reload the entire page for revision operations
        // Add event listener to expand specific revised record after reload
        if (mainFormRecord && mainFormRecord.uniqueId) {
          window.sessionStorage.setItem("expandRevisionUniqueId", mainFormRecord.uniqueId);
        } else if (mainFormRecord && mainFormRecord.id) {
          window.sessionStorage.setItem("expandRevisionRecordId", mainFormRecord.id);
        }
        window.sessionStorage.setItem('isRevisionOperation', 'true');
        window.sessionStorage.setItem('persistedPage', page);
        window.location.reload();
        // debouncedDefaultPageOneCallApi();
      } else {
        // For regular material control operations, just refresh data from API
        // debouncedDefaultPageOneCallApi();
      }
    }
  }, [openMainForm, mainFormType, mainFormRecord, closeMainForm, page]);

  // Temporarily using dummy values to test icon visibility
  // const [, canEdit, , canDelete] = UseDocControlPermissions();
  const canEdit = true;
  const canDelete = true;
  const [canViewRev] = UseRevisionsPermissions();
  const [canViewDist] = UseDistributionPermissions();

  const handleUpdateStatus = (isAdd, isUpdate) => {
    dispatch(
      updateProjectIsAddIsUpdate({
        isAddImsDoc: isAdd,
        isUpdateImsDoc: isUpdate,
      })
    );
  };

  useEffect(() => {
    // We're now managing loading state manually in handleFinish
    // but still sync with updateLoading for other cases
    if (!editingLoading) {
      setEditingLoading(updateLoading);
    }

    if (!updateLoading && !editingLoading) {
      setEditingKey("");
    }

    return () => {
      handleUpdateStatus(false, false);
    };
  }, [updateLoading]);

  const setUpdatedData = () => {
    let updatedData = allMaterialControl.map((el) => {
      const { document_attachments, ...rest } = el;

      let updatedImages;
      if (document_attachments?.length > 0) {
        updatedImages = document_attachments.map((img) => {
          const { url, id } = img;
          let name = url.split("/")[url.split("/").length - 1].split("?")[0];

          return { id, key: id, url, isLocal: false, name };
        });
      }

      return { ...rest, images: updatedImages };
    });
    setData(updatedData);
  };

  // Effect to expand first record after reload only for revision operations
  useEffect(() => {
    const expandRevisionUniqueId = window.sessionStorage.getItem('expandRevisionUniqueId');
    const expandRevisionRecordId = window.sessionStorage.getItem('expandRevisionRecordId');
    const isRevisionOperation = window.sessionStorage.getItem('isRevisionOperation');
    
    if (isRevisionOperation === 'true' && allMaterialControl.length > 0) {
      let recordToExpand;

      if(expandRevisionUniqueId) {
        recordToExpand = allMaterialControl.find(el => String(el.uniqueId) === String(expandRevisionUniqueId));
      }

      if(!recordToExpand && expandRevisionRecordId) {
        // Fallback to ID
        recordToExpand = allMaterialControl.find(el => String(editingKey.id) === String(expandRevisionRecordId))
      }

      if(recordToExpand) {
        setTimeout(()=> {
          view({ ...recordToExpand, isAdd: false, skipFilter: true});
          // Clear the flags
          window.sessionStorage.removeItem('expandRevisionUniqueId');
          window.sessionStorage.removeItem('expandRevisionRecordId');
          window.sessionStorage.removeItem('isRevisionOperation');
          window.sessionStorage.removeItem('persistedPage');
        }, 500);
      }
    }
  }, [allMaterialControl]);

  useEffect(() => {
    if (allMaterialControl.length === 0) {
      // Reset search result IDs when no results are found
      setSearchResultIds([]);
      return setData(allMaterialControl);
    } else if (allMaterialControl.length > 0) {
      setUpdatedData();
      
      // Check if there's an active search
      const hasActiveSearch = Object.keys(search).some(key => {
        // Check if the search field has a value
        return search[key] !== null && search[key] !== undefined && search[key] !== '' && 
               // For arrays (like document_template_id), check if they have elements
               (!Array.isArray(search[key]) || search[key].length > 0);
      });
      
      if (hasActiveSearch) {
        // Only extract IDs from search results when there's an active search
        const resultIds = allMaterialControl.map(item => item.id);
        setSearchResultIds(resultIds);
      } else {
        // Reset search result IDs when there's no active search
        setSearchResultIds([]);
      }
    }
  }, [allMaterialControl, search]);

  const edit = (record, openMainForm = false) => {
    let { type } = record;
    setAddType(type);
    
    if (type === "material") {
      type = "Material";
    }else if (type === "bolts") {
      type = "Bolts";
    }

    if (type === "Material") {
      // Set predefined fields for material form based on the image
      const materialFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field" },
        { id: "profileMember", name: "PROFILE / MEMBER", field_type: "text_field", required: true },
        { id: "materialSpec", name: "MATERIAL SPEC", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "paintArea", name: "PAINT AREA EACH (m²)", field_type: "text_field" },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "commodityId", name: "COMMODITY", field_type: "select_field", field_options: [
          { id: 1, name: "Commodity 1" },
          { id: 2, name: "Commodity 2" },
          { id: 3, name: "Commodity 3" }
        ] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field" },
        { id: "comments", name: "COMMENTS", field_type: "text_field" },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 4, name: "On Hold" },
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "date_field", disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "date_field", disabled: true },
      ];
      setFields(materialFields);
    } else if (type === "Bolts") {
      // Set predefined fields for bolts form based on the image
      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];

      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ?
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];

      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";

            // Check if field is a date field based on name or type
            if (field.type === "date" ||
              field.name.toLowerCase().includes("date") ||
              field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }

            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }

            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }

            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }

      const boltsFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "unitWeight", name: "UNIT WEIGHT (kg)", field_type: "text_field" },
        { id: "totalWeight", name: "TOTAL WEIGHT (kg)", field_type: "text_field" },
        { id: "size", name: "SIZE", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field" },
        { id: "materialFinish", name: "MATERIAL FINISH", field_type: "text_field", required: true },
        { id: "grade", name: "GRADE", field_type: "text_field", required: true },
        { id: "fastenerType", name: "FASTENER TYPE", field_type: "text_field", required: true },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field" },
        { id: "comments", name: "COMMENTS", field_type: "text_field" },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 4, name: "On Hold" },
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "date_field", disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "date_field", disabled: true },
        // Add template fields
        ...templateFields
      ];
      setFields(boltsFields);
    } else {
      // For other types, clear fields
      setFields([]);
    }

    // const currentUser = user ? `${record.createdBy.firstName} ${record.createdBy.lastName}` : "Joe Soap";
    const currentDateTime = record.createdAt ? moment(record.createdAt).format("DD MMM YYYY  HH:mm") : moment().format("DD MMM YYYY  HH:mm");


    if (type === "Bolts") {
      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];

      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ?
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];

      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";

            // Check if field is a date field based on name or type
            if (field.type === "date" ||
              field.name.toLowerCase().includes("date") ||
              field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }

            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }

            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }

            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }

      // Set default values for the form fields
      const initialValues = {
        // Standard fields for bolts form
        id: openMainForm? record.id : undefined,
        area: record.area,
        assemblyNo: record.assemblyNo,
        revision: record.revision || "00",
        qty: record.qty,
        materialTypeId: record.materialType ? record.materialTypeId : record.materialTypeId,
        areaName: record.areaName || "",
        originalPriorityId: record.originalPriorityId || undefined,
        newPriorityId: record.newPriorityId || undefined,
        unitSubtotal: record.unitSubtotal || "",
        unitWeight: record.unitWeight || undefined,
        totalWeight: record.totalWeight || undefined,
        size: record.size || "",
        length: record.length || "",
        model: record.model || undefined,
        materialFinish: record.materialFinish || "",
        grade: record.grade || "",
        fastenerType: record.fastenerType || "",
        supplierId: record.supplierId || undefined,
        commodityId: record.commodityId || undefined,
        attachments: record.attachments || [],
        documents: [],
        comments: record.comments || undefined,
        status: record.status || undefined,
        createdById: record.createdBy
          ? `${record.createdBy.firstName} ${record.createdBy.lastName}`
          : (record.username || "Joe Soap"),

        createdDate: record.createdAt
          ? moment(record.createdAt).format("DD MMM YYYY HH:mm")
          : moment().format("DD MMM YYYY HH:mm"),
        updatedById: user && `${user.firstName} ${user.lastName}` || record.updatedById && `${record.updatedBy.firstName} ${record.updatedBy.lastName}` || "-",
        modifiedDate: currentDateTime ? moment(currentDateTime).format("DD MMM YYYY HH:mm") : "-"
      };

      // Add any template-specific fields
      templateFields.forEach(field => {
        initialValues[field.id] = "";
      });

      // Set form values
      fieldsFormRef.setFieldsValue(initialValues);
      form.setFieldsValue(initialValues);
    }

    if (type === "Material") {
      // Get current user and date/time
      const currentUser = user ? `${user.firstName} ${user.lastName}` : "Joe Soap";
      const currentDateTime = moment().format("DD MMM YYYY  HH:mm");

      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];

      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ?
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];

      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";

            // Check if field is a date field based on name or type
            if (field.type === "date" ||
              field.name.toLowerCase().includes("date") ||
              field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }

            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }

            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }

            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }
      // Set default values for the form fields
      const initialValues = {
        // isAdd: true,
        id: openMainForm? record.id : undefined,
        area: record.area,
        assemblyNo: record.assemblyNo,
        revision: record.revision || "00",
        uniqueId: record.uniqueId,
        qty: record.qty,
        materialTypeId: record.materialType ? record.materialTypeId : record.materialTypeId,
        areaName: record.areaName,
        originalPriorityId: record.originalPriorityId || undefined,
        newPriorityId: record.newPriorityId || undefined,
        unitSubtotal: record.unitSubtotal,
        model: record.model || undefined, 
        profileMember: record.profileMember,
        materialSpec: record.materialSpec,
        length: record.length,
        paintArea: record.paintArea || undefined,
        supplierId: record.supplierId || undefined,
        commodityId: record.commodityId || undefined,
        attachments: record.attachments || [],
        documents: [],
        comments: record.comments || undefined,
        status: record.status || undefined,
        totalGross: record.qty * record.unitSubtotal || undefined,
        createdById: record.createdBy ? `${record.createdBy.firstName} ${record.createdBy.lastName}` : "-",
         createdDate: record.createdAt ? moment(record.createdAt).format("DD MMM YYYY HH:mm") : "-" ,
        updatedById: user && `${user.firstName} ${user.lastName}` || record.updatedById && `${record.updatedBy.firstName} ${record.updatedBy.lastName}` || "-",
        modifiedDate: currentDateTime
      };

      // Add any template-specific fields
      templateFields.forEach(field => {
        initialValues[field.id] = "";
      });

      // Set the fields state to include template fields
      const materialFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", required: false, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field", required: false },
        { id: "profileMember", name: "PROFILE / MEMBER", field_type: "text_field", required: true },
        { id: "materialSpec", name: "MATERIAL SPEC", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "paintArea", name: "PAINT AREA EACH (m²)", field_type: "text_field", required: false },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "commodityId", name: "COMMODITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Commodity 1" },
          { id: 2, name: "Commodity 2" },
          { id: 3, name: "Commodity 3" }
        ] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field", required: false },
        { id: "comments", name: "COMMENTS", field_type: "text_field", required: false },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 4, name: "On Hold" },
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", required: false, disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "text_field", required: false, disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", required: false, disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "text_field", required: false, disabled: true },
        // Add template fields
        ...templateFields
      ];

      setFields(materialFields);
      form.setFieldsValue(initialValues);
      fieldsFormRef.setFieldsValue(initialValues);
    }

    // setCurrentUpdateObj(record);

    // form.setFieldsValue({
    //   ...record,
    // });

    if (openMainForm) {
      setEditingKey(record.id);
      handleUpdateStatus(false, false);
    } else if (record.isAdd) {
      // For new records (created with handleTypeSelect), ensure isUpdateImsDoc is false
      setEditingKey(record.id);
      handleUpdateStatus(true, false);
    } else {
      // For existing records being edited
      setEditingKey(record.id);
      handleUpdateStatus(false, true);
    }
    setExpandedRowKeys([record.id]);
  };

  const view = (record, openMainForm = false) => {
    let { type } = record;
    setAddType(type);
    
    if (type === "material") {
      type = "Material";
    }else if (type === "bolts") {
      type = "Bolts";
    }

    // Initialize fields for the form
    if (type === "Material") {
      // Set predefined fields for material form based on the image
      const materialFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field" },
        { id: "profileMember", name: "PROFILE / MEMBER", field_type: "text_field", required: true },
        { id: "materialSpec", name: "MATERIAL SPEC", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "paintArea", name: "PAINT AREA EACH (m²)", field_type: "text_field" },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "commodityId", name: "COMMODITY", field_type: "select_field", field_options: [
          { id: 1, name: "Commodity 1" },
          { id: 2, name: "Commodity 2" },
          { id: 3, name: "Commodity 3" }
        ] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field" },
        { id: "comments", name: "COMMENTS", field_type: "text_field" },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 4, name: "On Hold" },
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "date_field", disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "date_field", disabled: true },
      ];
      setFields(materialFields);
    } else if (type === "Bolts") {
      // Set predefined fields for bolts form based on the image
      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];

      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ?
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];

      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";

            // Check if field is a date field based on name or type
            if (field.type === "date" ||
              field.name.toLowerCase().includes("date") ||
              field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }

            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }

            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }

            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }

      const boltsFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "unitWeight", name: "UNIT WEIGHT (kg)", field_type: "text_field" },
        { id: "totalWeight", name: "TOTAL WEIGHT (kg)", field_type: "text_field" },
        { id: "size", name: "SIZE", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field" },
        { id: "materialFinish", name: "MATERIAL FINISH", field_type: "text_field", required: true },
        { id: "grade", name: "GRADE", field_type: "text_field", required: true },
        { id: "fastenerType", name: "FASTENER TYPE", field_type: "text_field", required: true },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field" },
        { id: "comments", name: "COMMENTS", field_type: "text_field" },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 4, name: "On Hold" },
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "date_field", disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "date_field", disabled: true },
        // Add template fields
        ...templateFields
      ];
      setFields(boltsFields);
    } else {
      // For other types, clear fields
      setFields([]);
    }

    // handleUpdateStatus(true, false);
    // const key = record.id;
    // // type === "material" ? type = "Material" : type = "Bolts";
    // const newData = {
    //   key,
    //   id: key,
    //   isAdd: true,
    //   type: type,
    // };
    // let final = { ...newData };
    // setData((record) => [final, ...record]);
    // // edit(false);
    // setImages(record?.images || []);
    //
    // Get current user and date/time for all form types
    const currentUser = user ? `${user.first_name} ${user.surname}` : "Joe Soap";
    const currentDateTime = moment().format("DD MMM YYYY  HH:mm");

    // Initialize form values based on type
    if (type === "Bolts") {
      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];

      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ?
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];

      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";

            // Check if field is a date field based on name or type
            if (field.type === "date" ||
              field.name.toLowerCase().includes("date") ||
              field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }

            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }

            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }

            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }

      // Set default values for the form fields
      const initialValues = {
        // Standard fields for bolts form
        id: openMainForm? record.id : undefined,
        area: record.area,
        assemblyNo: record.assemblyNo,
        revision: record.revision || "00",
        qty: record.qty,
        materialTypeId: record.materialType ? record.materialTypeId : record.materialTypeId,
        areaName: record.areaName || "",
        originalPriorityId: record.originalPriorityId || undefined,
        newPriorityId: record.newPriorityId || undefined,
        unitSubtotal: record.unitSubtotal || "",
        unitWeight: record.unitWeight || undefined,
        totalWeight: record.totalWeight || undefined,
        size: record.size || "",
        length: record.length || "",
        model: record.model || undefined,
        materialFinish: record.materialFinish || "",
        grade: record.grade || "",
        fastenerType: record.fastenerType || "",
        supplierId: record.supplierId || undefined,
        commodityId: record.commodityId || undefined,
        attachments: record.attachments || [],
        documents: [],
        comments: record.comments || undefined,
        status: record.status || undefined,
        createdById: record.createdBy ? `${record.createdBy.firstName} ${record.createdBy.lastName}` : "Joe Soap",
        createdDate: record.createdAt ? moment(record.createdAt).format("DD MMM YYYY HH:mm") : "-" ,
        updatedById: user && `${user.firstName} ${user.lastName}` || record.updatedById && `${record.updatedBy.firstName} ${record.updatedBy.lastName}` || "-",
        modifiedDate: record.updatedAt ? moment(record.updatedAt).format("DD MMM YYYY HH:mm") : "-"
      };

      // Add any template-specific fields
      templateFields.forEach(field => {
        initialValues[field.id] = "";
      });

      // Set form values
      fieldsFormRef.setFieldsValue(initialValues);
      form.setFieldsValue(initialValues);
    }

    if (type === "Material") {
      // Get current user and date/time
      const currentUser = user ? `${user.firstName} ${user.lastName}` : "Joe Soap";
      const currentDateTime = moment().format("DD MMM YYYY  HH:mm");

      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];

      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ?
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];

      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";

            // Check if field is a date field based on name or type
            if (field.type === "date" ||
              field.name.toLowerCase().includes("date") ||
              field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }

            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }

            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }

            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }
      // Set default values for the form fields
      const initialValues = {
        // isAdd: true,
        id: openMainForm? record.id : undefined,
        area: record.area,
        assemblyNo: record.assemblyNo,
        revision: record.revision || "00",
        uniqueId: record.uniqueId,
        qty: record.qty,
        materialTypeId: record.materialType ? record.materialTypeId : record.materialTypeId,
        areaName: record.areaName,
        originalPriorityId: record.originalPriorityId || undefined,
        newPriorityId: record.newPriorityId || undefined,
        unitSubtotal: record.unitSubtotal,
        model: record.model || undefined, 
        profileMember: record.profileMember,
        materialSpec: record.materialSpec,
        length: record.length,
        paintArea: record.paintArea || undefined,
        supplierId: record.supplierId || undefined,
        commodityId: record.commodityId || undefined,
        attachments: record.attachments || [],
        documents: [],
        comments: record.comments || undefined,
        status: record.status || undefined,
        totalGross: record.qty * record.unitSubtotal || undefined,
        createdById: record.createdBy ? `${record.createdBy.firstName} ${record.createdBy.lastName}` : "",
        createdDate:record.createdAt,
        updatedById: user && `${user.firstName} ${user.lastName}` || record.updatedById && `${record.updatedBy.firstName} ${record.updatedBy.lastName}` || "-",
        modifiedDate: record.updatedAt ? moment(record.updatedAt).format("DD MMM YYYY HH:mm") : "-"
      };

      // Add any template-specific fields
      templateFields.forEach(field => {
        initialValues[field.id] = "";
      });

      // Set the fields state to include template fields
      const materialFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", required: false, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field", required: false },
        { id: "profileMember", name: "PROFILE / MEMBER", field_type: "text_field", required: true },
        { id: "materialSpec", name: "MATERIAL SPEC", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "paintArea", name: "PAINT AREA EACH (m²)", field_type: "text_field", required: false },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "commodityId", name: "COMMODITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Commodity 1" },
          { id: 2, name: "Commodity 2" },
          { id: 3, name: "Commodity 3" }
        ] },
        // { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field", required: false },
        { id: "comments", name: "COMMENTS", field_type: "text_field", required: false },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 4, name: "On Hold" }
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", required: false, disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "text_field", required: false, disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", required: false, disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "text_field", required: false, disabled: true },
        // Add template fields
        ...templateFields
      ];

      setFields(materialFields);
      form.setFieldsValue(initialValues);
      fieldsFormRef.setFieldsValue(initialValues);
    }

    // setCurrentUpdateObj(record);

    // form.setFieldsValue({
    //   ...record,
    // });

    if (openMainForm) {
      setEditingKey(record.id);
    }else{
      setEditingKey("");
    }
    handleUpdateStatus(false, false);
    setExpandedRowKeys([record.id]);
  }

  const cancel = () => {
    if (isUpdateImsDoc) {
      setData(data);
    } else {
      // if (editingKey) {
      let filteredItems = data.filter((el) => el.id !== editingKey);
      let final = filteredItems.filter((el) => el.key !== editingKey);
      setData(final);
      // }
    }
    setFields([]);
    form.resetFields();
    fieldsFormRef.resetFields();
    handleUpdateStatus(false, false);
    setEditingKey("");
    setExpandedRowKeys([]);
  };

  const save = async (key) => {
    try {
      // Validate both forms
      const row = await form.validateFields();
      const formFields = await fieldsFormRef.validateFields();

      // IMPORTANT: Get the current form values BEFORE clearing the editing key
      // This ensures we capture all form values while the form is still in edit mode
      const currentValues = form.getFieldsValue();
      const expandedFormValues = fieldsFormRef.getFieldsValue();

      // Store these values for use in handleFinish
      window.savedFormValues = {
        mainForm: currentValues,
        expandedForm: expandedFormValues
      };

      // Set loading state immediately
      setEditingLoading(true);

      // Create a copy of the data array
      const newData = [...data];
      const index = newData.findIndex(
        (item) => key === item.key || key === item.id
      );

      if (index > -1) {
        // Create a temporary record with the current form values
        const tempRecord = {
          ...newData[index],
          ...currentValues,
          ...expandedFormValues,
          // Keep the key and id intact
          key: newData[index].key,
          id: newData[index].id,
          // Mark as saving to show loading state
          // _isSaving: true
        };
        // Update the data array with the temporary record
        newData[index] = tempRecord;
        setData(newData);

        // Now that we've captured the form values, we can clear the editing key
        // This will switch the form to view mode
        // setEditingKey("");

        // Submit the form which will trigger handleFinish
        form.submit();
      }
    } catch (errInfo) {
      const { errorFields } = errInfo;
      errorFields.forEach((el) => {
        el.errors[0] !== "Required!" && message.error(el.errors[0]);
      });
      // Make sure to reset loading state if validation fails
      setEditingLoading(false);
    }
  };

  // Fetch all areas for the dropdown using the dedicated areas API endpoint
  const getUniqueAreas = async () => {
    try {
      if (!project_id) return [];

      const resp = await axios.get(`${baseURL}/material-control-registers/areas?projectId=${project_id}`);
      const items = resp?.data?.data || [];

      // Return all records from the API (not deduplicated)
      return items.map((item, index) => ({
        label: `${item.area} - ${item.areaName}`,
        value: `${item.area}-${item.areaName}-${index}`, // Use a composite value to ensure uniqueness
        area: item.area, // Store original area for filtering
        areaName: item.areaName, // Store original areaName
      }));
    } catch (e) {
      console.error('Failed to fetch areas', e);
      return [];
    }
  };

  const [areaOptions, setAreaOptions] = useState([]);
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [areaDropdownVisible, setAreaDropdownVisible] = useState(false);

  // Fetch area options once per project (not tied to table page)
  useEffect(() => {
    let mounted = true;
    (async () => {
      const opts = await getUniqueAreas();
      if (mounted) setAreaOptions(opts);
    })();
    return () => { mounted = false; };
  }, [project_id]);

  // State for project priorities
  const [priorities, setPriorities] = useState([]);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [priorityDropdownVisible, setPriorityDropdownVisible] = useState(false);
  
  // Fetch project priorities
  useEffect(() => {
    const fetchPriorities = async () => {
      if (project_id) {
        try {
          const response = await axios.get(`/project/${project_id}`);
          if (response.status === 200) {
            const formattedPriorities = response.data.priorities.map(priority => ({
              label: priority.name || '',
              value: priority.id
            }));
            setPriorities(formattedPriorities);
          }
        } catch (error) {
          console.error('Error fetching project priorities:', error);
        }
      }
    };
    
    fetchPriorities();
  }, [project_id]);

  // Tracking stage status options
  const trackingStatusOptions = [
    { label: 'Not Started', value: 'not_started' },
    { label: 'Received', value: 'received' },
    { label: 'In Progress', value: 'in_progress' },
    { label: 'Completed', value: 'completed' },
    { label: 'On Hold', value: 'on_hold' }
  ];
  
  // State for tracking stage filters
  const [fabricationStatusFilter, setFabricationStatusFilter] = useState([]);
  const [qcReleaseStatusFilter, setQcReleaseStatusFilter] = useState([]);
  const [corrosionProtectionStatusFilter, setCorrosionProtectionStatusFilter] = useState([]);
  const [deliveryToSiteStatusFilter, setDeliveryToSiteStatusFilter] = useState([]);
  const [siteReceiptStatusFilter, setSiteReceiptStatusFilter] = useState([]);
  
  // State for tracking stage dropdown visibility
  const [fabricationDropdownVisible, setFabricationDropdownVisible] = useState(false);
  const [qcReleaseDropdownVisible, setQcReleaseDropdownVisible] = useState(false);
  const [corrosionProtectionDropdownVisible, setCorrosionProtectionDropdownVisible] = useState(false);
  const [deliveryToSiteDropdownVisible, setDeliveryToSiteDropdownVisible] = useState(false);
  const [siteReceiptDropdownVisible, setSiteReceiptDropdownVisible] = useState(false);
  
  // State for priority multi-select filter
  const [priorityStatusFilter, setPriorityStatusFilter] = useState([]);
  
  // State for material type multi-select filter
  const [materialTypeStatusFilter, setMaterialTypeStatusFilter] = useState([]);
  const [materialTypeDropdownVisible, setMaterialTypeDropdownVisible] = useState(false);

  // Handle area checkbox change
  const handleAreaCheckboxChange = (area) => {
    const newSelectedAreas = [...selectedAreas];
    const areaIndex = newSelectedAreas.indexOf(area);
    
    if (areaIndex === -1) {
      // If not selected, add it
      newSelectedAreas.push(area);
    } else {
      // If already selected, remove it
      newSelectedAreas.splice(areaIndex, 1);
    }
    
    setSelectedAreas(newSelectedAreas);
  };
  
  // Handle select all areas
  const handleSelectAllAreas = (e) => {
    if (e.target.checked) {
      // Select all areas
      setSelectedAreas(areaOptions.map(option => option.value));
    } else {
      // Deselect all areas
      setSelectedAreas([]);
    }
  };
  
  // Apply area filter
  const applyAreaFilter = () => {
    // Extract the original area values from selected composite values
    const areaValues = selectedAreas.length > 0 
      ? selectedAreas.map(compositeValue => {
          // Extract the area from the composite value (format: area-areaName-index)
          const option = areaOptions.find(opt => opt.value === compositeValue);
          return option ? option.area : compositeValue.split('-')[0];
        })
      : undefined;
    
    // Apply the filter here
    setSearch(prev => ({
      ...prev,
      area: areaValues
    }));
    setAreaDropdownVisible(false); // Close the dropdown
    debouncedDefaultPageOneCallApi();
  };
  
  // Handle priority selection
  const handlePrioritySelect = (priority) => {
    // If the same priority is selected, clear it
    if (selectedPriority === priority) {
      setSelectedPriority(null);
    } else {
      // Otherwise set the new selected priority
      setSelectedPriority(priority);
    }
    
    // Close dropdown after selection
    setPriorityDropdownVisible(false);
    
    // Apply filter immediately
    setSearch(prev => ({
      ...prev,
      priorityId: priority || undefined
    }));
    debouncedDefaultPageOneCallApi();
  };
  
  // Clear priority filter
  const clearPriorityFilter = () => {
    setSelectedPriority(null);
    setSearch(prev => ({
      ...prev,
      priorityId: undefined
    }));
    debouncedDefaultPageOneCallApi();
    setPriorityDropdownVisible(false);
  };

  // Handle priority checkbox changes
  const handlePriorityCheckboxChange = (priorityValue) => {
    const newSelection = [...priorityStatusFilter];
    const priorityIndex = newSelection.indexOf(priorityValue);
    
    if (priorityIndex === -1) {
      newSelection.push(priorityValue);
    } else {
      newSelection.splice(priorityIndex, 1);
    }
    
    setPriorityStatusFilter(newSelection);
  };

  // Handle Select All checkbox for priorities
  const handleSelectAllPriorities = (e) => {
    if (e.target.checked) {
      setPriorityStatusFilter(priorities.map(priority => priority.value));
    } else {
      setPriorityStatusFilter([]);
    }
  };

  // Handle material type checkbox changes
  const handleMaterialTypeCheckboxChange = (materialTypeValue) => {
    const newSelection = [...materialTypeStatusFilter];
    const materialTypeIndex = newSelection.indexOf(materialTypeValue);
    
    if (materialTypeIndex === -1) {
      newSelection.push(materialTypeValue);
    } else {
      newSelection.splice(materialTypeIndex, 1);
    }
    
    setMaterialTypeStatusFilter(newSelection);
  };

  // Handle Select All checkbox for material types
  const handleSelectAllMaterialTypes = (e) => {
    if (e.target.checked) {
      setMaterialTypeStatusFilter(dynamicMaterialTypeOptions.map(option => option.value));
    } else {
      setMaterialTypeStatusFilter([]);
    }
  };

  // Apply priority filter function
  const applyPriorityFilter = () => {
    const priorityIdString = priorityStatusFilter.length > 0 ? priorityStatusFilter.join(',') : '';
    const newSearch = {
      ...search,
      priorityId: priorityIdString,
    };
    console.log('Priority filter applied:', { priorityStatusFilter, priorityIdString, newSearch });
    setSearch(newSearch);
    setPriorityDropdownVisible(false);
    debouncedDefaultPageOneCallApi();
  };

  // Apply material type filter function
  const applyMaterialTypeFilter = () => {
    const materialTypeIdString = materialTypeStatusFilter.length > 0 ? materialTypeStatusFilter.join(',') : '';
    const newSearch = {
      ...search,
      materialType: materialTypeIdString,
    };
    console.log('Material type filter applied:', { materialTypeStatusFilter, materialTypeIdString, newSearch });
    setSearch(newSearch);
    setMaterialTypeDropdownVisible(false);
    debouncedDefaultPageOneCallApi();
  };

  // Custom dropdown content for material type multi-select
  const materialTypeDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={handleSelectAllMaterialTypes}
          checked={materialTypeStatusFilter.length === dynamicMaterialTypeOptions.length && dynamicMaterialTypeOptions.length > 0}
          indeterminate={materialTypeStatusFilter.length > 0 && materialTypeStatusFilter.length < dynamicMaterialTypeOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {dynamicMaterialTypeOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={materialTypeStatusFilter.includes(option.value)}
              onChange={() => handleMaterialTypeCheckboxChange(option.value)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyMaterialTypeFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );

  // Custom dropdown content for priority multi-select
  const priorityDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={handleSelectAllPriorities}
          checked={priorityStatusFilter.length === priorities.length && priorities.length > 0}
          indeterminate={priorityStatusFilter.length > 0 && priorityStatusFilter.length < priorities.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {priorities.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={priorityStatusFilter.includes(option.value)}
              onChange={() => handlePriorityCheckboxChange(option.value)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyPriorityFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );

  // Handle tracking stage status checkbox changes
  const handleTrackingStatusCheckboxChange = (status, currentSelection, setSelection) => {
    const newSelection = [...currentSelection];
    const statusIndex = newSelection.indexOf(status);
    
    if (statusIndex === -1) {
      newSelection.push(status);
    } else {
      newSelection.splice(statusIndex, 1);
    }
    
    setSelection(newSelection);
  };

  // Handle Select All checkbox for tracking stages
  const handleSelectAllTrackingStatus = (e, setSelection) => {
    if (e.target.checked) {
      setSelection(trackingStatusOptions.map(option => option.value));
    } else {
      setSelection([]);
    }
  };

  // Apply tracking stage filter functions
  const applyFabricationFilter = () => {
    setSearch({
      ...search,
      fabricationStatuses: fabricationStatusFilter,
    });
    setFabricationDropdownVisible(false);
    debouncedDefaultPageOneCallApi();
  };

  const applyQcReleaseFilter = () => {
    setSearch({
      ...search,
      qcReleaseStatuses: qcReleaseStatusFilter,
    });
    setQcReleaseDropdownVisible(false);
    debouncedDefaultPageOneCallApi();
  };

  const applyCorrosionProtectionFilter = () => {
    setSearch({
      ...search,
      corrosionProtectionStatuses: corrosionProtectionStatusFilter,
    });
    setCorrosionProtectionDropdownVisible(false);
    debouncedDefaultPageOneCallApi();
  };

  const applyDeliveryToSiteFilter = () => {
    setSearch({
      ...search,
      deliveryToSiteStatuses: deliveryToSiteStatusFilter,
    });
    setDeliveryToSiteDropdownVisible(false);
    debouncedDefaultPageOneCallApi();
  };

  const applySiteReceiptFilter = () => {
    setSearch({
      ...search,
      siteReceiptStatuses: siteReceiptStatusFilter,
    });
    setSiteReceiptDropdownVisible(false);
    debouncedDefaultPageOneCallApi();
  };

  // Custom dropdown content for areas
  const areaDropdownContent = (
    <div className="area-dropdown-content">
      <div className="area-dropdown-content-header">
        <Checkbox 
          onChange={handleSelectAllAreas}
          checked={selectedAreas.length === areaOptions.length && areaOptions.length > 0}
          indeterminate={selectedAreas.length > 0 && selectedAreas.length < areaOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="area-dropdown-content-body">
        {areaOptions.map(option => (
          <div key={option.value} className="area-option">
            <Checkbox 
              checked={selectedAreas.includes(option.value)}
              onChange={() => handleAreaCheckboxChange(option.value)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="area-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyAreaFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for Fabrication status
  const fabricationDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setFabricationStatusFilter)}
          checked={fabricationStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={fabricationStatusFilter.length > 0 && fabricationStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={fabricationStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, fabricationStatusFilter, setFabricationStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyFabricationFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for QC Release status
  const qcReleaseDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setQcReleaseStatusFilter)}
          checked={qcReleaseStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={qcReleaseStatusFilter.length > 0 && qcReleaseStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={qcReleaseStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, qcReleaseStatusFilter, setQcReleaseStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyQcReleaseFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for Corrosion Protection status
  const corrosionProtectionDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setCorrosionProtectionStatusFilter)}
          checked={corrosionProtectionStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={corrosionProtectionStatusFilter.length > 0 && corrosionProtectionStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={corrosionProtectionStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, corrosionProtectionStatusFilter, setCorrosionProtectionStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyCorrosionProtectionFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for Delivery to Site status
  const deliveryToSiteDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setDeliveryToSiteStatusFilter)}
          checked={deliveryToSiteStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={deliveryToSiteStatusFilter.length > 0 && deliveryToSiteStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={deliveryToSiteStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, deliveryToSiteStatusFilter, setDeliveryToSiteStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyDeliveryToSiteFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for Site Receipt status
  const siteReceiptDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setSiteReceiptStatusFilter)}
          checked={siteReceiptStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={siteReceiptStatusFilter.length > 0 && siteReceiptStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={siteReceiptStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, siteReceiptStatusFilter, setSiteReceiptStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applySiteReceiptFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );

  const searchInput = (key) => {
    if (key === "area") {
      return (
        <Dropdown 
          overlay={areaDropdownContent} 
          trigger={['click']} 
          visible={areaDropdownVisible}
          onVisibleChange={(visible) => {
            // Only update if the dropdown is being opened or closed by clicking outside
            // This prevents the dropdown from closing when clicking inside it
            if (!visible || !areaDropdownVisible) {
              setAreaDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '350px' }}
        >
          <Input
            placeholder={""}
            value={selectedAreas.length > 0 ? selectedAreas.length : ""}
            readOnly
            className="area-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "fabrication") {
      return (
        <Dropdown 
          overlay={fabricationDropdownContent} 
          trigger={['click']} 
          visible={fabricationDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !fabricationDropdownVisible) {
              setFabricationDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={fabricationStatusFilter.length > 0 ? fabricationStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "qcRelease") {
      return (
        <Dropdown 
          overlay={qcReleaseDropdownContent} 
          trigger={['click']} 
          visible={qcReleaseDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !qcReleaseDropdownVisible) {
              setQcReleaseDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={qcReleaseStatusFilter.length > 0 ? qcReleaseStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "corrosionProtection") {
      return (
        <Dropdown 
          overlay={corrosionProtectionDropdownContent} 
          trigger={['click']} 
          visible={corrosionProtectionDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !corrosionProtectionDropdownVisible) {
              setCorrosionProtectionDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={corrosionProtectionStatusFilter.length > 0 ? corrosionProtectionStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "deliveryToSite") {
      return (
        <Dropdown 
          overlay={deliveryToSiteDropdownContent} 
          trigger={['click']} 
          visible={deliveryToSiteDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !deliveryToSiteDropdownVisible) {
              setDeliveryToSiteDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={deliveryToSiteStatusFilter.length > 0 ? deliveryToSiteStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "siteReceipt") {
      return (
        <Dropdown 
          overlay={siteReceiptDropdownContent} 
          trigger={['click']} 
          visible={siteReceiptDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !siteReceiptDropdownVisible) {
              setSiteReceiptDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={siteReceiptStatusFilter.length > 0 ? siteReceiptStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "priority") {
      return (
        <Dropdown 
          overlay={priorityDropdownContent} 
          trigger={['click']} 
          visible={priorityDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !priorityDropdownVisible) {
              setPriorityDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={priorityStatusFilter.length > 0 ? priorityStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "materialType") {
      return (
        <Dropdown 
          overlay={materialTypeDropdownContent} 
          trigger={['click']} 
          visible={materialTypeDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !materialTypeDropdownVisible) {
              setMaterialTypeDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={materialTypeStatusFilter.length > 0 ? materialTypeStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    }
    return (
      <Input
        placeholder={""}
        onClick={(e) => e.stopPropagation()}
        value={search[key] || ""}
        onChange={(e) => {
          setSearch({
            ...search,
            [key]: e.target.value,
          });
          debouncedDefaultPageOneCallApi();
        }}
      />
    );
  };

  // const handleDateInput = (value) => {
  //   setDate(value);
  //   if (value === null) {
  //     setSearch({
  //       ...search,
  //       document_start_date: "",
  //       document_end_date: "",
  //     });
  //   } else {
  //     setSearch({
  //       ...search,
  //       document_start_date: value[0],
  //       document_end_date: value[1],
  //     });
  //   }
  //   debouncedDefaultPageOneCallApi();
  // };

  // const handleDueDateInput = (value) => {
  //   setDueDate(value);
  //   if (value === null) {
  //     setSearch({
  //       ...search,
  //       document_due_data: "",
  //       document_due_end_data: "",
  //     });
  //   } else {
  //     setSearch({
  //       ...search,
  //       document_due_data: value[0],
  //       document_due_end_data: value[1],
  //     });
  //   }
  //   debouncedDefaultPageOneCallApi();
  // };

  const handleMultiSelect = (list, key) => {
    setSearch({
      ...search,
      [key]: list,
    });
    // debouncedDefaultPageOneCallApi();
  };

  const handleSelectOnchange = (value, options, key, setHandler) => {
    if (value.includes("all")) {
      setHandler([...options.map((item) => item.value)]);
      value = options.map((item) => item.value);
    } else if (value.includes("not-all")) {
      setHandler([]);
      value = [];
    } else {
      setHandler(value);
    }
    handleMultiSelect(value, key);
  };

  const onDeleteSuccess = () => {
    debouncedCallApi();
    setDeleteDocId();
    debouncedDefaultPageOneCallApi();
  };

  const deleteDocHandler = (record) => {
    setDeleteDocId(record.id);
    dispatch(deleteMaterialControl({ ...record, project_id, onDeleteSuccess }));
  };

  // Column names defined directly
  const getColumnName = (i) => {
    const columnNames = [
      "Area",
      "Assembly No",
      "Rev",
      "Unique Id",
      "Qty",
      "Material Type",
      "Total /Gross",
      "Priority",
      "Fabrication",
      "QC Release",
      "CORROS. PROT.\n/DEL. WRKSHP.",
      "Delivery\n to Site",
      "Site Receipt",
      "% Compl.",
      "% Instl."
    ];
    return columnNames[i] || `Column ${i + 1}`;
  };

  // const dateInput = (key) => (
  //   <DatePicker
  //     style={{ width: "100%", minWidth: "80px" }}
  //     placeholder=""
  //     onClick={(e) => {
  //       e.preventDefault();
  //       e.stopPropagation();
  //     }}
  //     className="activities-time-picker prod-due-date"
  //     getPopupContainer={() =>
  //       document.getElementsByClassName(
  //         "ant-layout-content layout-content site-layout-background custom-textarea"
  //       )[0]
  //     }
  //     suffixIcon={null}
  //     format="D MMM YYYY"
  //     // popupClassName="activities-time-picker"
  //     onChange={(e) => {
  //       setSearch({
  //         ...search,
  //         [key]: e,
  //       });
  //       debouncedCallApi();
  //     }}
  //     onOpenChange={(e) => setDatePickerOpened(e)}
  //   />
  // );

  const handleColOnClick = (record) => {
    if (
      isAddImsDoc ||
      ((isRevisionUpdateCase || isUpdateImsDoc) &&
        expandedRowKeys[0] !== record.id)
    ) {
      setExpandedRowKeys([]);
      setIsRevisionUpdateCase(false);
      setEditingKey("");
      setIsRevisionUpdateCase(false);
      handleUpdateStatus(false, false);
      setUpdatedData();
      form.resetFields();
      fieldsFormRef.resetFields();
      setExpandedRowKeys([record.id]);
      setFields([]);
      setIsRevisionUpdateCase(true);
      return view({ ...record, isAdd: false, skipFilter: true });
    }

    if (isRevisionUpdateCase) {
      if (expandedRowKeys[0] === record.id) {
        setExpandedRowKeys([]);
        setIsRevisionUpdateCase(false);
        setEditingKey("");
        setIsRevisionUpdateCase(false);
        handleUpdateStatus(false, false);
      }
    } else {
      setExpandedRowKeys([record.id]);
      setIsRevisionUpdateCase(true);
      view({ ...record, isAdd: false, skipFilter: false });
    }

    // if (!isAddImsDoc && !isUpdateImsDoc) {
    // setExpandedRowKeys([record.id]);
    // setIsRevisionUpdateCase(editingKey == record.id ? false : true);
    // edit({ ...record, isAdd: false });
    // }
  };

  const handleSearchOnchange = (value) => {
    if (value === undefined) {
      setAttachSearch(null);
      handleMultiSelect("", "has_attach");
    } else {
      setAttachSearch(value);
      handleMultiSelect(value, "has_attach");
    }
    debouncedDefaultPageOneCallApi();
  };

  // Function to handle increasing the counter for an item
  const handleIncreaseCount = (record, e) => {
    e.stopPropagation(); // Prevent row click event
    
    // Set this item as having its plus button clicked
    setPlusButtonClicked(prev => ({
      ...prev,
      [record.id]: true
    }));
    
    setSelectedItems(prev => {
      const newSelectedItems = { ...prev };
      const recordId = record.id;
      
      // Get material type from the record
      const materialType = record.materialType?.materialType || 'unknown';
      const uom = record.materialType?.uom || '';
      
      // Initialize material type group if it doesn't exist
      if (!newSelectedItems[materialType]) {
        newSelectedItems[materialType] = {
          items: {},
          uom: uom
        };
      }
      
      if (!newSelectedItems[materialType].items[recordId]) {
        // First time adding this item, store all details
        newSelectedItems[materialType].items[recordId] = {
          id: recordId,
          qty: 1,
          model: record.model || '',
          markNo: record.uniqueId || '',
          uniqueId: record.uniqueId || '',
          description: record.areaName || '',
          totalGross: record.totalGross,
          materialType: materialType,
          uom: uom,
          progressStepType: selectedDeliveryNoteType
        };
      } else {
        // Item already exists, just increase the quantity
        newSelectedItems[materialType].items[recordId].qty += 1;
      }
      
      // Calculate total count by summing all quantities across all material types
      let totalCount = 0;
      Object.keys(newSelectedItems).forEach(matType => {
        if (newSelectedItems[matType].items) {
          Object.values(newSelectedItems[matType].items).forEach(item => {
            totalCount += (item.qty || 0);
          });
        }
      });
      
      setSelectedItemsCount(totalCount);
      
      console.log(`Item ${recordId} count increased to ${newSelectedItems[materialType].items[recordId].qty}`);
      console.log('Selected items:', newSelectedItems);
      
      return newSelectedItems;
    });
  };

  // Function to handle direct input changes in the counter field
  const handleDirectCountChange = (record, e) => {
    e.stopPropagation(); // Prevent row click event
    
    const newValue = parseInt(e.target.value) || 0;
    
    // Set this item as having its plus button clicked if value > 0
    setPlusButtonClicked(prev => ({
      ...prev,
      [record.id]: newValue > 0
    }));
    
    setSelectedItems(prev => {
      const newSelectedItems = { ...prev };
      const recordId = record.id;
      
      // Get material type from the record
      const materialType = record.materialType?.materialType || 'unknown';
      const uom = record.materialType?.uom || '';
      
      if (newValue <= 0) {
        // Remove item if value is 0 or negative
        if (newSelectedItems[materialType] && newSelectedItems[materialType].items[recordId]) {
          delete newSelectedItems[materialType].items[recordId];
          
          // If no items left in this material type, remove the material type
          if (Object.keys(newSelectedItems[materialType].items).length === 0) {
            delete newSelectedItems[materialType];
          }
        }
      } else {
        // Initialize material type group if it doesn't exist
        if (!newSelectedItems[materialType]) {
          newSelectedItems[materialType] = {
            items: {},
            uom: uom
          };
        }
        
        if (!newSelectedItems[materialType].items[recordId]) {
          // First time adding this item, store all details
          newSelectedItems[materialType].items[recordId] = {
            id: recordId,
            qty: newValue,
            model: record.model || '',
            markNo: record.uniqueId || '',
            uniqueId: record.uniqueId || '',
            description: record.areaName || '',
            totalGross: record.totalGross,
            materialType: materialType,
            uom: uom
          };
        } else {
          // Item already exists, update the quantity
          newSelectedItems[materialType].items[recordId].qty = newValue;
        }
      }
      
      // Calculate total count by summing all quantities across all material types
      let totalCount = 0;
      Object.keys(newSelectedItems).forEach(matType => {
        if (newSelectedItems[matType].items) {
          Object.values(newSelectedItems[matType].items).forEach(item => {
            totalCount += (item.qty || 0);
          });
        }
      });
      
      setSelectedItemsCount(totalCount);
      
      console.log(`Item ${recordId} count set to ${newValue}`);
      console.log('Selected items:', newSelectedItems);
      
      return newSelectedItems;
    });
  };
  
  // Function to handle decreasing the counter for an item
  const handleDecreaseCount = (record, e) => {
    e.stopPropagation(); // Prevent row click event
    
    setSelectedItems(prev => {
      const newSelectedItems = { ...prev };
      const recordId = record.id;
      
      // Get material type from the record
      const materialType = record.materialType?.materialType || 'unknown';
      
      // Check if this material type and item exist
      if (newSelectedItems[materialType] && 
          newSelectedItems[materialType].items && 
          newSelectedItems[materialType].items[recordId] && 
          newSelectedItems[materialType].items[recordId].qty > 0) {
        
        // Decrease the quantity
        newSelectedItems[materialType].items[recordId].qty -= 1;
        
        // Remove item if count is 0
        if (newSelectedItems[materialType].items[recordId].qty === 0) {
          delete newSelectedItems[materialType].items[recordId];
          
          // Also remove from plusButtonClicked if count is 0
          setPlusButtonClicked(prevClicked => {
            const newClicked = { ...prevClicked };
            delete newClicked[recordId];
            return newClicked;
          });
          
          // If no more items in this material type, remove the material type
          if (Object.keys(newSelectedItems[materialType].items).length === 0) {
            delete newSelectedItems[materialType];
          }
        }
      }
      
      // Calculate total count by summing all quantities across all material types
      let totalCount = 0;
      Object.keys(newSelectedItems).forEach(matType => {
        if (newSelectedItems[matType].items) {
          Object.values(newSelectedItems[matType].items).forEach(item => {
            totalCount += (item.qty || 0);
          });
        }
      });
      
      setSelectedItemsCount(totalCount);
      
      // Get current quantity for logging
      let currentQty = 0;
      if (newSelectedItems[materialType] && 
          newSelectedItems[materialType].items && 
          newSelectedItems[materialType].items[recordId]) {
        currentQty = newSelectedItems[materialType].items[recordId].qty;
      }
      
      console.log(`Item ${recordId} count decreased to ${currentQty}`);
      console.log('Selected items after decrease:', newSelectedItems);
      
      return newSelectedItems;
    });
  };

  // Define the counter column separately
  const counterColumn = {
    title: () => {
      return null; // No title for counter column
    },
    dataIndex: "counter",
    key: "counter",
    width: 80,
    render: (_, record) => {
      // Get the material type from the record
      const materialType = record.materialType?.materialType || 'unknown';
      const recordId = record.id;
      
      // If batchUpdateGrv is selected, show checkbox instead of counter
      if (selectedDeliveryNoteType === 'batchUpdateGrv') {
        const isChecked = selectedItems[materialType]?.items?.[recordId]?.qty > 0 || false;
        
        return (
          <div 
            className="checkbox-cell" 
            onClick={(e) => e.stopPropagation()}
            style={{ 
              display: 'flex', 
              justifyContent: 'center',
              alignItems: 'center',
              width: '70px',
              height: '30px'
            }}
          >
            <Checkbox
              checked={isChecked}
              className="grv-checkbox"
              onChange={(e) => {
                const checked = e.target.checked;
                const materialType = record.materialType?.materialType || 'unknown';
                const recordId = record.id;
                
                setSelectedItems(prevItems => {
                  const newSelectedItems = { ...prevItems };
                  
                  if (!newSelectedItems[materialType]) {
                    newSelectedItems[materialType] = { 
                      items: {},
                      uom: record.materialType?.uom || ''
                    };
                  }
                  
                  if (!newSelectedItems[materialType].items) {
                    newSelectedItems[materialType].items = {};
                  }
                  
                  if (checked) {
                    // Add item with qty 1 when checked
                    newSelectedItems[materialType].items[recordId] = {
                      ...record,
                      qty: 1
                    };
                    
                    // Mark plus button as clicked for styling consistency
                    setPlusButtonClicked(prev => ({
                      ...prev,
                      [recordId]: true
                    }));
                  } else {
                    // Remove item when unchecked
                    delete newSelectedItems[materialType].items[recordId];
                    
                    // Remove plus button clicked state
                    setPlusButtonClicked(prev => ({
                      ...prev,
                      [recordId]: false
                    }));
                    
                    // Clean up empty material type
                    if (Object.keys(newSelectedItems[materialType].items).length === 0) {
                      delete newSelectedItems[materialType];
                    }
                  }
                  
                  // Calculate total count for the counter
                  let totalCount = 0;
                  Object.keys(newSelectedItems).forEach(materialType => {
                    if (newSelectedItems[materialType].items) {
                      Object.keys(newSelectedItems[materialType].items).forEach(itemId => {
                        totalCount += newSelectedItems[materialType].items[itemId].qty || 0;
                      });
                    }
                  });
                  
                  setSelectedItemsCount(totalCount);
                  
                  return newSelectedItems;
                });
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        );
      }
      
      // Default counter behavior for other delivery note types
      const count = selectedItems[materialType]?.items?.[recordId]?.qty || 0;
      
      return (
        <div 
          className="counter-cell" 
          onClick={(e) => e.stopPropagation()}
          style={{ 
            display: 'flex', 
            border: plusButtonClicked[record.id] ? '1px solid #f25003' : '1px solid #d9d9d9', 
            borderRadius: '2px',
            width: '70px',
            height: '30px',
            overflow: 'hidden'
          }}
        >
          <button 
            className="counter-btn minus-btn" 
            onClick={(e) => handleDecreaseCount(record, e)}
            style={{ 
              border: 'none', 
              borderRight: plusButtonClicked[record.id] ? '1px solid #f25003' : '1px solid #d9d9d9',
              background: 'white', 
              flex: '1 1 33.33%',
              width: '33.33%',
              height: '100%',
              cursor: 'pointer',
              fontSize: '16px',
              color:  plusButtonClicked[record.id] ? '#f25003' : '#999',
              minWidth: 0
            }}
          >
            −
          </button>
          <input
            type="number"
            min="0"
            value={count}
            onChange={(e) => handleDirectCountChange(record, e)}
            onClick={(e) => e.stopPropagation()}
            className="counter-input-no-spinner"
            style={{ 
              flex: '1 1 33.33%', 
              width: '33.33%',
              border: 'none',
              borderRight: plusButtonClicked[record.id] ? '1px solid #f25003' : '1px solid #d9d9d9',
              fontSize: '14px',
              textAlign: 'center',
              outline: 'none',
              background: 'transparent',
              minWidth: 0,
              padding: '0 2px'
            }}
          />
          <button 
            className="counter-btn plus-btn" 
            onClick={(e) => handleIncreaseCount(record, e)}
            style={{ 
              border: 'none',
              background: 'white', 
              flex: '1 1 33.33%',
              width: '33.33%',
              height: '100%',
              cursor: 'pointer',
              fontSize: '16px',
              color:  plusButtonClicked[record.id] ? '#f25003' : '#999',
              minWidth: 0
            }}
          >
            +
          </button>
        </div>
      );
    },
  };

  // Define the main columns array without the counter column
  const baseColumns = [
    {
      title: () => {
        return (
          <div align="left" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(0)}</div>
            <div>{searchInput("area")}</div>
          </div>
        );
      },
      dataIndex: "area",
      key: "area",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "area" && sortedInfo?.order,
      width: 55,
      editable: !isRevisionUpdateCase,
      render: (area, record) => {
        return (
          <div onClick={() => handleColOnClick(record)}>
            {record?.area}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(1)}</div>
            <div>{searchInput("assemblyNo")}</div>
          </div>
        );
      },
      dataIndex: "assemblyNo",
      key: "assemblyNo",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "assemblyNo" && sortedInfo?.order,
      width: 85,
      editable: !isRevisionUpdateCase,
      render: (assemblyNo, record) => {
        return (
          <div onClick={() => handleColOnClick(record)}>
            {record?.assemblyNo}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(2)}</div>
            <div>{searchInput("revision")}</div>
          </div>
        );
      },
      dataIndex: "revision",
      key: "revision",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "revision" && sortedInfo?.order,
      width: 60,
      editable: !isRevisionUpdateCase,
      render: (revision, record) => (
        <div onClick={() => handleColOnClick(record)}>
          {record?.revision}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(3)}</div>
            <div>{searchInput("uniqueId")}</div>
          </div>
        );
      },
      dataIndex: "uniqueId",
      key: "uniqueId",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "uniqueId" && sortedInfo?.order,
      width: 110,
      editable: revisionRecord && revisionRecord.id ? false : (addType === "Material" ? true : false),
      render: (uniqueId, record) => (
        <div onClick={() => handleColOnClick(record)}>
          {record?.uniqueId}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(4)}</div>
            <div>{searchInput("qty")}</div>
          </div>
        );
      },
      dataIndex: "qty",
      key: "qty",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "qty" && sortedInfo?.order,
      width: 60,
      editable: !isRevisionUpdateCase,
      render: (qty, record) => (
        <div onClick={() => handleColOnClick(record)}>
          {record?.qty}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(5)}</div>
            <div>{searchInput("materialType")}</div>
          </div>
        );
      },
      dataIndex: "materialTypeId",
      key: "materialTypeId",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "materialTypeId" && sortedInfo?.order,
      width: 105,
      editable: !isRevisionUpdateCase,
      render: (materialTypeId, record) => (
        <div onClick={() => handleColOnClick(record)}>{record.materialType ? record.materialType.materialType : materialTypeId}</div>
      ),
    },
    {
      title: () => {
        return (
          <div align="left" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(6)}</div>
            <div>{searchInput("totalGross")}</div>
          </div>
        );
      },
      dataIndex: "totalGross",
      key: "totalGross",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "totalGross" && sortedInfo?.order,
      width: 90,
      align: "center",
      // editable: !isRevisionUpdateCase,
      editable: false,
      render: (totalGross, record) => {
        return (
          <div onClick={() => handleColOnClick(record)}>
            {record?.type === "material" || record?.type === "Material" && record?.materialType?.uom ?
              record?.totalGross + " " + record?.materialType?.uom :
              record?.totalGross
            }
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(7)}</div>
            <div>{searchInput("priority")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: "priority",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "priority" && sortedInfo?.order,
      width: 100,
      align: "left",
      editable: !isRevisionUpdateCase,
      className: "less-padding-col",
      render: (priority, record) => (
        <div onClick={() => handleColOnClick(record)}>
          {(record?.newPriority || record?.originalPriority) && (
            <div
              className="priority-badge"
              style={{
                backgroundColor: (record.newPriority || record.originalPriority).color || '#D9D9D9',
                color: '#000',
                border: 'none'
              }}
            >
              {record.newPriority ? record.newPriority.name : record.originalPriority.name}
            </div>
          )}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="left" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(8)}</div>
            <div>{searchInput("fabrication")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: "fabrication",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "fabrication" && sortedInfo?.order,
      width: 90,
      className: "comment-td less-padding-col",
      editable: !isRevisionUpdateCase,
      render: (fabrication, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[0], record, lastActiveStepIndex === 0, 'Fabrication')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="left" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(9)}</div>
            <div>{searchInput("qcRelease")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: "qc_release",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "qc_release" && sortedInfo?.order,
      width: 90,
      editable: !isRevisionUpdateCase,
      align: "center",
      render: (qcRelease, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[1], record, lastActiveStepIndex === 1, 'QC Release')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="left" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(10)}</div>
            <div>{searchInput("corrosionProtection")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: "corrosion_protection",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "corrosion_protection" && sortedInfo?.order,
      width: 90,
      editable: !isRevisionUpdateCase,
      align: "center",
      render: (corrosionProtection, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[2], record, lastActiveStepIndex === 2, 'Corrosion Protection')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="left" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(11)}</div>
            <div>{searchInput("deliveryToSite")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: "delivery_to_site",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "delivery_to_site" && sortedInfo?.order,
      width: 90,
      editable: !isRevisionUpdateCase,
      align: "center",
      render: (deliveryToSite, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[3], record, lastActiveStepIndex === 3, 'Delivery to Site')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="left" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(12)}</div>
            <div>{searchInput("siteReceipt")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: "site_receipt",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "site_receipt" && sortedInfo?.order,
      width: 90,
      editable: !isRevisionUpdateCase,
      align: "center",
      render: (siteReceipt, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[4], record, lastActiveStepIndex === 4, 'Site Receipt')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(13)}</div>
            <div>{searchInput("perComplete")}</div>
          </div>
        );
      },
      dataIndex: "perComplete",
      key: "perComplete",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "perComplete" && sortedInfo?.order,
      width: 70,
      editable: !isRevisionUpdateCase,
      align: "center",
      render: (perComplete, record) => {
        return (
          <div onClick={() => handleColOnClick(record)}>{`${Math.round(record.perComplete || 0)}%`}</div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(14)}</div>
            <div>{searchInput("perInstalled")}</div>
          </div>
        );
      },
      dataIndex: "perInstalled",
      key: "perInstalled",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "perInstalled" && sortedInfo?.order,
      width: 70,
      editable: !isRevisionUpdateCase,
      align: "center",
     render: (perInstalled, record) => {
        // Check if installation step needs authorization (installed qty > expected qty AND not authorized)
        const installationStep = record.progressSteps?.find(step => step.type === 'installation');
        const installedQty = installationStep?.completedQty || 0;
        const expectedQty = record.qty || 1;
        const isAuthorized = !!installationStep?.completedAuthorizedById;

        // If installed qty exceeds expected qty and step is not authorized, show 0%
        const needsAuth = installedQty > expectedQty && !isAuthorized;
        const displayPercentage = needsAuth ? 0 : Math.round(record.perInstalled || 0);

        return (
          <div onClick={() => handleColOnClick(record)}>{`${displayPercentage}%`}</div>
        );
      },
    },
    {
      title: "",
      dataIndex: "operation",
      align: "center",
      width: 40,
      render: (_, record) => {
        const editable = isEditing(record);
        let key = record?.key || record?.id;

        let shouldDisabled =
          isAddImsDoc ||
          (isRevisionUpdateCase && !editable) ||
          (isUpdateImsDoc && editingKey !== key);

        // Check if this record is in saving state
        const isSaving = record._isSaving && editingLoading;

        // Show spinner if this record is being saved
        if (isSaving) {
          return <SpinnerComponent fontSize={14} />;
        }

        if (editable && !isRevisionUpdateCase) {
          // Edit mode - show save and cancel buttons
          return (
            <Space size={20} align="center">
              <Popconfirm
                placement="topRight"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                overlayClassName="activities-popconfirm"
                title="Are you sure you want to save this Document?"
                onConfirm={() => save(record.key || record.id)}
                okText="Yes"
                cancelText="No"
              >
                <SaveIcon className="custom-icon" />
              </Popconfirm>
              <Popconfirm
                placement="topRight"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                title="Are you sure you want to cancel?"
                onConfirm={cancel}
                okText="Yes"
                cancelText="No"
              >
                <CrossIcon
                  className="custom-icon"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              </Popconfirm>
            </Space>
          );
        } else {
          // View mode - show edit and delete buttons
          return (
            <Space size={20} align="center">
              {deletingLoading && record.id === deleteDocId ? (
                <SpinnerComponent fontSize={16} />
              ) : (
                <>
                  {canEdit && mcPermissions?.edit?.admin_add_edit_delete && (
                    <EditIcon
                      className={`custom-icon`}
                      onClick={() => {
                        {
                          edit({
                            ...record,
                            isAdd: false,
                            skipFilter: false,
                          });
                          setIsRevisionUpdateCase(false);
                        }
                      }}
                    />
                  )}
                  {canDelete && mcPermissions?.edit?.admin_add_edit_delete && (
                      <Popconfirm
                        getPopupContainer={() =>
                          document.getElementsByClassName(
                            "ant-layout-content layout-content site-layout-background custom-textarea"
                          )[0]
                        }
                        placement="topRight"
                        title="Are you sure you want to delete this Document?"
                        onConfirm={() => deleteDocHandler(record)}
                      >
                        <DeleteIcon className={`custom-icon`} />
                      </Popconfirm>
                  )}
                </>
              )}
            </Space>
          );
        }
      },
    },
  ];

  // Conditionally include the counter column based on selectedDeliveryNoteType
  const columns = selectedDeliveryNoteType 
    ? [counterColumn, ...baseColumns] 
    : baseColumns;

  const handleTypeSelect = (type) => {
    setAddType(type);
    setDropdownVisible(false);

    // Initialize fields for the form
    if (type === "Material") {
      // Set predefined fields for material form based on the image
      const materialFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field" },
        { id: "profileMember", name: "PROFILE / MEMBER", field_type: "text_field", required: true },
        { id: "materialSpec", name: "MATERIAL SPEC", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "paintArea", name: "PAINT AREA EACH (m²)", field_type: "text_field" },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "commodityId", name: "COMMODITY", field_type: "select_field", field_options: [
          { id: 1, name: "Commodity 1" },
          { id: 2, name: "Commodity 2" },
          { id: 3, name: "Commodity 3" }
        ] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field" },
        { id: "comments", name: "COMMENTS", field_type: "text_field" },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 4, name: "On Hold" },
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "date_field", disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "date_field", disabled: true },
      ];
      setFields(materialFields);
    } else if (type === "Bolts") {
      // Set predefined fields for bolts form based on the image
      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];
      
      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ? 
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];
      
      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";
            
            // Check if field is a date field based on name or type
            if (field.type === "date" || 
                field.name.toLowerCase().includes("date") || 
                field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }
            
            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }
            
            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }
            
            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }
      
      const boltsFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "unitWeight", name: "UNIT WEIGHT (kg)", field_type: "text_field" },
        { id: "totalWeight", name: "TOTAL WEIGHT (kg)", field_type: "text_field" },
        { id: "size", name: "SIZE", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field" },
        { id: "materialFinish", name: "MATERIAL FINISH", field_type: "text_field", required: true },
        { id: "grade", name: "GRADE", field_type: "text_field", required: true },
        { id: "fastenerType", name: "FASTENER TYPE", field_type: "text_field", required: true },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field" },
        { id: "comments", name: "COMMENTS", field_type: "text_field" },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 4, name: "On Hold" },
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "date_field", disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "date_field", disabled: true },
        // Add template fields
        ...templateFields
      ];
      setFields(boltsFields);
    } else {
      // For other types, clear fields
      setFields([]);
    }
    
    form.resetFields();
    fieldsFormRef.resetFields();
    setSortedInfo(null);
    handleUpdateStatus(true, false);
    setCurrentUpdateObj({});
    let key = Math.ceil(Math.random() * 2345678);
    const newData = {
      key,
      id: key,
      area: "",
      assemblyNo: "",
      revision: "",
      uniqueId: "",
      qty: "",
      materialTypeId: undefined,
      username: user.first_name + " " + user.surname,
      isAdd: true,
      type: type,
    };
    let final = { ...newData };
    setData((data) => [final, ...data]);
    edit(final);
    setImages([]);
    
    // Get current user and date/time for all form types
    const currentUser = user ? `${user.first_name} ${user.surname}` : "Joe Soap";
    const currentDateTime = moment().format("DD MMM YYYY  HH:mm");
    
    // Initialize form values based on type
    if (type === "Bolts") {
      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];
      
      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ? 
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];
      
      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";
            
            // Check if field is a date field based on name or type
            if (field.type === "date" || 
                field.name.toLowerCase().includes("date") || 
                field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }
            
            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }
            
            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }
            
            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }
      
      // Set default values for the form fields
      const initialValues = {
        ...newData,
        // Standard fields for bolts form
        areaName: "",
        originalPriorityId: undefined,
        newPriorityId: undefined,
        unitSubtotal: "",
        unitWeight: undefined,
        totalWeight: "",
        size: "",
        length: "",
        model: undefined,
        materialFinish: "",
        grade: "",
        fastenerType: "",
        supplierId: undefined,
        attachments: [],
        documents: [],
        comments: undefined,
        status: undefined,
        createdById: user ? `${user.firstName} ${user.lastName}` : "Joe Soap",
        createdDate: currentDateTime,
        updatedById: "-",
        modifiedDate: "-"
      };
      
      // Add any template-specific fields
      templateFields.forEach(field => {
        initialValues[field.id] = "";
      });
      
      // Set form values
      fieldsFormRef.setFieldsValue(initialValues);
      form.setFieldsValue(initialValues);
    }
    
    // Initialize form values for Material type
    if (type === "Material") {
      // Get current user and date/time
      const currentUser = user ? `${user.firstName} ${user.lastName}` : "Joe Soap";
      const currentDateTime = moment().format("DD MMM YYYY  HH:mm");
      
      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];
      
      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ? 
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];
      
      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";
            
            // Check if field is a date field based on name or type
            if (field.type === "date" || 
                field.name.toLowerCase().includes("date") || 
                field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }
            
            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }
            
            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }
            
            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }
      
      // Set default values for the form fields
      const initialValues = {
        ...newData,
        // Standard fields
        areaName: "",
        originalPriorityId: undefined,
        newPriorityId: undefined,
        unitSubtotal: "",
        model: undefined,
        profileMember: "",
        materialSpec: "",
        length: "",
        paintArea: undefined,
        supplierId: undefined,
        commodityId: undefined,
        attachments: [],
        documents: [],
        comments: undefined,
        status: undefined,
        createdById: currentUser, // Current user name
        createdDate: currentDateTime, // Current date and time
        updatedById: "-",
        modifiedDate: "-"
      };
      
      // Add any template-specific fields
      templateFields.forEach(field => {
        initialValues[field.id] = "";
      });
      
      // Set the fields state to include template fields
      const materialFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, 
          field_options: [{id: 1, name: "Priority 1"}, {id: 2, name: "Priority 2"}, {id: 3, name: "Priority 3"}] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", required: false, 
          field_options: [{id: 1, name: "Priority 1"}, {id: 2, name: "Priority 2"}, {id: 3, name: "Priority 3"}] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field", required: false },
        { id: "profileMember", name: "PROFILE / MEMBER", field_type: "text_field", required: true },
        { id: "materialSpec", name: "MATERIAL SPEC", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "paintArea", name: "PAINT AREA EACH (m²)", field_type: "text_field", required: false },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", required: true, 
          field_options: [{id: 1, name: "Supplier 1"}, {id: 2, name: "Supplier 2"}, {id: 3, name: "Supplier 3"}] },
        { id: "commodityId", name: "COMMODITY", field_type: "select_field", required: true, 
          field_options: [{id: 1, name: "Commodity 1"}, {id: 2, name: "Commodity 2"}, {id: 3, name: "Commodity 3"}] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field", required: false },
        { id: "comments", name: "COMMENTS", field_type: "text_field", required: false },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, 
          field_options: [{id: 1, name: "Active"}, {id: 2, name: "Inactive"}, {id: 3, name: "Pending"}] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", required: false, disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "text_field", required: false, disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", required: false, disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "text_field", required: false, disabled: true },
        // Add template fields
        ...templateFields
      ];
      
      setFields(materialFields);
      form.setFieldsValue(initialValues);
      fieldsFormRef.setFieldsValue(initialValues);
    } else {
      form.setFieldsValue({
        ...newData,
      });
    }

    setEditingKey(key);
    setExpandedRowKeys([key]);
  };
  
  const handleAdd = () => {
    setDropdownVisible(true);
  };

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => {
        return {
          record,
          // inputType:,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
        };
      },
    };
  });

  const handleFinish = (item) => {
    let formValues = {};
    let mainFormValues = {};
    
    if (window.savedFormValues) {
      mainFormValues = window.savedFormValues.mainForm || {};
      formValues = window.savedFormValues.expandedForm || {};
      
      window.savedFormValues = null;
    } else {
      formValues = fieldsFormRef.getFieldsValue();
      mainFormValues = form.getFieldsValue();
    }
    
    // Extract basic fields from item
    const {
      area,
      material_type_id,
      document_status_id,
      document_due_date,
      sheets,
      comment,
    } = item;

    // Process date fields
    let dueDateisValid = moment(document_due_date).isValid();
    let duedate = dueDateisValid ? moment(document_due_date) : null;
    
    let formType = "material"; // Default type
    
    if (formValues.size && formValues.length && 
        (formValues.grade || formValues.fastenerType)) {
      formType = "bolts";
    }
    // Check if this is a revision type from the addType state
    // if (addType === "Revision") {
    //   formType = "revision";
    // }
    // If item already has a type, use that
    if (item && item.type) {
      formType = item.type;
    }
    
    const filteredItem = {};
    
    ['id', 'key'].forEach(prop => {
      if (item && item[prop] !== undefined) {
        filteredItem[prop] = item[prop];
      }
    });
    
    if (formType === "material") {
      ['area', 'assemblyNo', 'revision', 'uniqueId', 'qty', 'materialTypeId'].forEach(prop => {
        if (item && item[prop] !== undefined) {
          filteredItem[prop] = item[prop];
        }
      });
    } else if (formType === "bolts") {
      ['area', 'revision', 'qty', 'materialTypeId'].forEach(prop => {
        if (item && item[prop] !== undefined) {
          filteredItem[prop] = item[prop];
        }
      });
    }
    // Restructure formValues for Material type to organize dynamic fields into materialTemplateFields object
    let processedFormValues = { ...formValues };
    console.log("processedFormValues", processedFormValues);
    
    if (formType === "material") {
      // Define standard fields that should remain at the root level
      const standardFields = [
        'areaName', 'attachments', 'comments', 'commodityId', 'createdById', 'createdDate',
        'length', 'materialSpec', 'model', 'updatedById', 'modifiedDate', 'newPriorityId',
        'originalPriorityId', 'paintArea', 'profileMember', 'status', 'supplierId', 'unitSubtotal',
        'area', 'assemblyNo', 'revision', 'uniqueId', 'qty', 'materialTypeId', 'onHoldReason',
        'onHoldById', 'onHoldAt', 'documents'
      ];

      // Remove specific fields
      delete processedFormValues.createdDate;
      delete processedFormValues.updatedById;
      delete processedFormValues.modifiedDate;
      
      // Set createdById to user.id
     processedFormValues.createdById = user.id;
      
      // Create materialTemplateFields object for dynamic fields
      const materialTemplateFields = {};
      
      // Identify and move dynamic fields to materialTemplateFields
      Object.keys(formValues).forEach(key => {
        // Check if the field is a dynamic template field (not in standardFields)
        if (!standardFields.includes(key)) {
          // Convert all values to strings to ensure consistency
          materialTemplateFields[key] = formValues[key] !== null && formValues[key] !== undefined ? String(formValues[key]) : '';
          // Remove from the root level
          delete processedFormValues[key];
        }
      });
      
      // Add materialTemplateFields to processedFormValues if there are any dynamic fields
      if (Object.keys(materialTemplateFields).length > 0) {
        processedFormValues.materialTemplateFields = materialTemplateFields;
      }

      // Set totalGross equal to unitSubtotal if it exists
      if (processedFormValues.unitSubtotal) {
        processedFormValues.totalGross = (processedFormValues.unitSubtotal * filteredItem.qty).toFixed(2);
      }
      
      // Set priority based on newPriorityId or originalPriorityId
      if (processedFormValues.newPriorityId !== undefined) {
        processedFormValues.priority = processedFormValues.newPriorityId;
      } else if (processedFormValues.originalPriorityId !== undefined) {
        processedFormValues.priority = processedFormValues.originalPriorityId;
      }
    }else if(formType === "bolts"){
      const standardFields = [
        'areaName', 'originalPriorityId', 'newPriorityId', 'materialTypeId', 'unitSubtotal', 'unitWeight', 'totalWeight',
        'size', 'length', 'model', 'revision', 'materialFinish', 'grade', 'fastenerType', 'supplierId', 'attachments',
        'comments', 'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate', 'onHoldReason', 'onHoldById',
        'onHoldAt', 'documents'
      ];

      delete processedFormValues.createdDate;
      delete processedFormValues.updatedById;
      delete processedFormValues.modifiedDate;
      
      processedFormValues.createdById = user.id;
      // In the form submission logic, replace the existing totalWeight calculation with:
      if (processedFormValues.unitWeight !== undefined && filteredItem.qty !== undefined) {
        const unitWeight = parseFloat(processedFormValues.unitWeight);
        const qty = parseFloat(filteredItem.qty);
        
        if (!isNaN(unitWeight) && !isNaN(qty)) {
          processedFormValues.totalWeight = unitWeight * qty;
        } else {
          // If either value is not a valid number, set totalWeight to 0 or null
          processedFormValues.totalWeight = 0;
        }
      } else {
          // If either value is missing, set totalWeight to 0 or null
          processedFormValues.totalWeight = 0;
      }

      const materialTemplateFields = {};
      
      // Identify and move dynamic fields to materialTemplateFields
      Object.keys(formValues).forEach(key => {
        // Check if the field is a dynamic template field (not in standardFields)
        if (!standardFields.includes(key)) {
          // Convert all values to strings to ensure consistency
          materialTemplateFields[key] = formValues[key] !== null && formValues[key] !== undefined ? String(formValues[key]) : '';
          // Remove from the root level
          delete processedFormValues[key];
        }
      });
      
      // Add materialTemplateFields to processedFormValues if there are any dynamic fields
      if (Object.keys(materialTemplateFields).length > 0) {
        processedFormValues.materialTemplateFields = materialTemplateFields;
      }
      
      // Set totalGross equal to unitSubtotal if it exists
      if (processedFormValues.unitSubtotal) {
        processedFormValues.totalGross = (processedFormValues.unitSubtotal * filteredItem.qty).toFixed(2);
      }
      
      // Set priority based on newPriorityId or originalPriorityId
      if (processedFormValues.newPriorityId !== undefined) {
        processedFormValues.priority = processedFormValues.newPriorityId;
      } else if (processedFormValues.originalPriorityId !== undefined) {
        processedFormValues.priority = processedFormValues.originalPriorityId;
      }
    }



    if (processedFormValues.status === "On Hold") {
      processedFormValues.onHoldById = user.id;
      processedFormValues.onHoldAt = moment().format("YYYY-MM-DD HH:mm:ss");
    }
    const mergedItem = {
      ...filteredItem,
      projectId: parseInt(project_id),
      type: formType,
      ...processedFormValues
    };

    // Add files to the mergedItem for now (will be handled by the saga)
    if (formType === "material") {
      ['area', 'assemblyNo', 'revision', 'uniqueId', 'qty', 'materialTypeId'].forEach(prop => {
        if (formValues[prop] !== undefined) {
          mergedItem[prop] = formValues[prop];
        }
      });
    } else if (formType === "bolts") {
      ['area', 'revision', 'qty', 'materialTypeId'].forEach(prop => {
        if (formValues[prop] !== undefined) {
          mergedItem[prop] = formValues[prop];
        }
      });
    }

    const savedData = [...data];
    if (revisionRecord) {
      mergedItem.id = revisionRecord.id;
    }
    const updatedData = [...data];
    const index = updatedData.findIndex(record => record.id === item.id || record.key === item.key);
    
    if (index > -1) {
      updatedData[index] = {
        ...updatedData[index],
        ...mergedItem,
      };
      setData(updatedData);
    }
    if (isUpdateImsDoc) {

      mergedItem.id = expandedRowKeys[0];
      mergedItem.updatedById = user.id;
      // Dispatch the action without expecting a Promise
      dispatch(
        updateMaterialControl({
          ...mergedItem,
          ...(images.length > 0 && { images }),
          // debouncedDefaultPageOneCallApi,
          onSuccess: (  responseData ) => {
            // API call completed successfully
            // Now we can safely clear the editing state and show the view mode
            setEditingLoading(false);
            setEditingKey(""); // Clear editing state
            
            // Update the data to remove the saving flag
            const finalData = [...data];
            const recordIndex = finalData.findIndex(record => record.id === item.id || record.key === item.key);
         if (recordIndex > -1) {
           finalData[recordIndex] = {
                ...finalData[recordIndex],
                ...responseData, 
             _isSaving: false
           };
              setData(finalData);
            }
            
            // Reset expanded row state
            // setExpandedRowKeys([]);
            
            // Reset the update flags
            handleUpdateStatus(false, false);
            
            // // Refresh the data
            // debouncedDefaultPageOneCallApi();
          },
          onError: (error) => {
            // API call failed, revert to previous state
            console.error("Error updating material control:", error);
            setData(savedData);
            setEditingLoading(false);
            handleUpdateStatus(false, false);
            message.error("Failed to update. Please try again.");
          }
        })
      )
    } else {
      // Dispatch the action without expecting a Promise
      dispatch(
        createMaterialControl({
          ...mergedItem,
          ...(images.length > 0 && { images }),
          debouncedDefaultPageOneCallApi,
          onSuccess: (responseData) => {
            // API call completed successfully
            setEditingLoading(false);
            
            // Get the newly created record ID from the response
            const newRecordId = responseData?.id;
            
            // Manually fetch the latest data while preserving expanded row state
            if (newRecordId) {
              // Fetch just this specific record to update our local state
              axios.get(`${baseURL}/material-control-registers/${newRecordId}`)
                .then(response => {
                  if (response.status === 200) {
                    const newRecord = response.data;
                    
                    // Update the data array with the new record
                    const finalData = [...data].slice(1);
                    const recordIndex = finalData.findIndex(record => 
                      record.id === newRecordId || record.key === item.key
                    );
                    
                    if (recordIndex > -1) {
                      // Update existing record
                      finalData[recordIndex] = {
                        ...finalData[recordIndex],
                        ...newRecord,
                        _isSaving: false
                      };
                      setData(finalData);
                      
                      // Call view() function with the updated record
                      view(finalData[recordIndex]);
                    } else {
                      // Add new record to the data array
                      const updatedData = [newRecord, ...data];
                      setData(updatedData);
                      
                      // Call view() function with the new record
                      view(newRecord);
                    }
                  }
                })
                .catch(error => {
                  console.error("Error fetching new record:", error);
                  setEditingKey("");
                });
            } else {
              // If no record ID, just update the UI state
              const finalData = [...data];
              const recordIndex = finalData.findIndex(record => record.id === item.id || record.key === item.key);
              if (recordIndex > -1) {
                finalData[recordIndex] = {
                  ...finalData[recordIndex],
                  _isSaving: false
                };
                setData(finalData);
                view(finalData[recordIndex]);
              } else {
                setEditingKey("");
              }
            }
          },
          onError: (error) => {
            // API call failed, revert to previous state
            console.error("Error creating material control:", error);
            // setData(savedData);
            setEditingLoading(false);
            message.error("Failed to create. Please try again.");
          }
        })
      );
    }
  };

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    // Force a data refresh when sorting changes
    debouncedCallApi();
  };

  // Effect to fetch data when sortedInfo changes
  useEffect(() => {
    if (sortedInfo) {
      dispatch(
        fetchMaterialControl({
          page,
          perPage: resultPerPage,
          search,
          orderBy: sortedInfo?.order && sortedInfo?.columnKey,
          orderDirection: sortedInfo?.order
            ? sortedInfo?.order === "ascend"
              ? "asc"
              : "desc"
            : null,
          ...filter,
          projectId: project_id,
          onPermissionError,
        })
      );
    }
  }, [sortedInfo?.columnKey, sortedInfo?.order]); // Only trigger on actual sort changes

  useEffect(() => {
    if (selectedDeliveryNoteType) {
      let search = {};
      if (selectedDeliveryNoteType === 'qcRelease') {
        search = { qcReleaseStatuses: ['completed', 'in_progress'], corrosionProtectionStatuses: ['not_started', 'received', 'in_progress'] };
      } else if (selectedDeliveryNoteType === 'deliveryNoteCorrisonProtection') {
        search = { corrosionProtectionStatuses: ['completed', 'in_progress'], deliveryToSiteStatuses: ['not_started', 'received', 'in_progress'] };
      } else if (selectedDeliveryNoteType === 'deliveryToSite') {
        search = { deliveryToSiteStatuses: ['completed', 'in_progress'], siteReceiptStatuses: ['not_started', 'received', 'in_progress'] };
      }
      if (selectedDeliveryNoteType === 'signedDeliveryNoteCorrisonProtection') {
        search = { qcReleaseStatuses: ['completed', 'in_progress'], corrosionProtectionStatuses: ['not_started'] };
      }
      if (selectedDeliveryNoteType === 'signedDeliveryToSite') {
        search = { corrosionProtectionStatuses: ['completed', 'in_progress'], deliveryToSiteStatuses: ['not_started'] };
      }
      if (selectedDeliveryNoteType === 'signedSiteReceipt') {
        search = { deliveryToSiteStatuses: ['completed', 'in_progress'], siteReceiptStatuses: ['not_started'] };
      }
      if (selectedDeliveryNoteType === 'batchUpdateGrv') {
        search = {siteReceiptStatuses: ['received', 'in_progress', 'completed']}; // Add specific search criteria for batch update GRV if needed
      }

      dispatch(
        fetchMaterialControl({
          page,
          perPage: resultPerPage,
          search,
          orderBy: sortedInfo?.order && sortedInfo?.columnKey,
          orderDirection: sortedInfo?.order
            ? sortedInfo?.order === "ascend"
              ? "asc"
              : "desc"
            : null,
          ...filter,
          projectId: project_id,
          onPermissionError,
          deliveryNoteType: selectedDeliveryNoteType
        })
      );
    }
  }, [selectedDeliveryNoteType]);

  const expandedRowRender = (record) => {
    if (expandedRowKeys.includes(record.id)) {
      let { material_type_id } = form.getFieldsValue();
      // if (material_type_id > 0) {
      return (
        <>
          {fields.length > 0 && (
            <ExpandedRow
              record={currentMaterialControl?.id === record.id ? currentMaterialControl : record}
              fields={fields}
              formRef={fieldsFormRef}
              onFinish={onFinishFields}
              isRevisionUpdateCase={isRevisionUpdateCase}
              project_id={project_id}
              isEditing={isEditing(record)}
              editingKey={editingKey}
              viewMode={viewMode}
              editingLoading={editingLoading}
              mcPermissions={mcPermissions}
              onTrackingStageStatusUpdate={handleTrackingStageStatusUpdate}
              refetchParams={{
                page,
                perPage: resultPerPage,
                search,
                sort: sortedInfo?.order && sortedInfo?.columnKey,
                order: sortedInfo?.order
                  ? sortedInfo?.order === "ascend"
                    ? "asc"
                    : "desc"
                  : null,
                onPermissionError
              }}
            />
          )}
          {/* {isRevisionUpdateCase && ( */}
          <Row gutter={[0, 60]} style={{ marginBottom: "30px" }}>
            {record.revision && canViewRev && (
              <Col span={24}>
                <Revisions record={record} mcPermissions={mcPermissions}/>
              </Col>
            )}
            {/* {record?.document_template?.distribution_control && canViewDist && (
              <Col span={24}>
                <Distribution record={record} />
              </Col>
            )} */}
          </Row>
          {/* )} */}
        </>
      );
      // }
    }
  };

  const handleChangeDocType = (id) => {
    // Add defensive check to prevent error when allTemplates is undefined
    const template = Array.isArray(allTemplates) ? allTemplates.filter((el) => el.id === id)[0] : null;
    // Material templates have fields instead of template_fields
    const template_fields = template ? template.fields || [] : [];
    let values = {};
    if (template_fields.length > 0) {
      template_fields.forEach((el) => (values[el.id] = ""));
    }
    fieldsFormRef.setFieldsValue({ ...values });
    setFields(template_fields);
  };

  const onFinishFields = (values) => {
  };

  const handleCloseBatchSection = () => {
    setShowBatch(false);
  };

  const handleCloseFilterSection = () => {
    setShowFilter(false);
    setFilter({});
    handleCloseBatchSection();
    debouncedDefaultPageOneCallApi();
  };

  const handleFilter = (filterObj) => {
    setFilter(filterObj);
    console.log("filterObj", filterObj);
    debouncedDefaultPageOneCallApi();
  };

  const handleBatchUpdate = (filterObj) => {
    setExpandedRowKeys([]);
    setEditingKey("");
    setIsRevisionUpdateCase(false);
    let document_control = data.map((el) => el.id);
    let revisions_ids = [];
    let distributions_ids = [];
    data.map((doc) => {
      const { doc_distributions, doc_revisions } = doc;
      doc_revisions.map((rev) => revisions_ids.push(rev.id));
      doc_distributions.map((dist) => distributions_ids.push(dist.id));
    });
    dispatch(
      fetchProjectBatchUpdate({
        ...filterObj,
        document_control,
        project_id,
        revisions_ids,
        distributions_ids,
      })
    );
  };

  const shouldAddBtnDisable = () => {
    let shouldDisabled =
      isAddImsDoc || fetchDocsLoading || isRevisionUpdateCase || isUpdateImsDoc;
    return shouldDisabled;
  };

  const hanldeBatch = () => {
    if (canEdit) {
      setShowFilter(true);
      setShowBatch(true);
    }
  };

  let material_type_id = form.getFieldValue("material_type_id");
  // Add defensive check for dueDateRequired calculation
  const selectedTemplate = Array.isArray(allTemplates) 
    ? allTemplates.filter((template) => template.id === material_type_id)[0] 
    : null;
  let dueDateRequired = selectedTemplate?.turnaround_time || false;

  return (
    <Row className="doc-control-parent-row">
      <Col span={24} className="heading-col">
        <Row align="middle" gutter={[50, 0]} justify="space-between">
          <Col>
            <Row gutter={[50, 0]} align="middle">
              <Col>
                <div>
                  <span className="heading-span" style={{ color: "#000" }}>
                    MATERIAL CONTROL REGISTER
                  </span>
                </div>
              </Col>
              {canEdit && !selectedDeliveryNoteType && (
                <Col>
                  {!dropdownVisible ? (
                    <Button
                      icon={<PlusOutlined />}
                      className="add-doc-btn"
                      size="middle"
                      onClick={handleAdd}
                      disabled={shouldAddBtnDisable()}
                    >
                      ADD
                    </Button>
                  ) : (
                    <div style={{ width: '250px' }}>
                      {/* <div style={{ fontWeight: 'bold', color: '#000', marginBottom: '5px' }}>
                        TYPE
                      </div> */}
                      <Select
                        defaultValue="Select Type"
                        style={{ width: '100%' }}
                        onChange={(value) => handleTypeSelect(value)}
                        onBlur={() => setDropdownVisible(false)}
                        autoFocus
                        open={true}
                        dropdownStyle={{ width: '250px' }}
                      >
                        <Select.Option value="Material">Material</Select.Option>
                        <Select.Option value="Bolts">Bolts</Select.Option>
                      </Select>
                    </div>
                  )}
                </Col>
              )}
            </Row>
          </Col>
          <Col>
            <Row justify="end">
              <Col>
                <Space size={20} align="center">
                  <div style={{ textAlign: 'right', marginRight: '10px' }}>
                    {(selectedDeliveryNoteType === 'deliveryNoteCorrisonProtection' || 
                      selectedDeliveryNoteType === 'qcRelease' || 
                      selectedDeliveryNoteType === 'deliveryToSite') && (
                      <div style={{ fontSize: '12px' }}>Select items to add to Delivery Note:</div>
                    )}
                    {(selectedDeliveryNoteType === 'signedDeliveryNoteCorrisonProtection' || 
                      selectedDeliveryNoteType === 'signedDeliveryToSite' || 
                      selectedDeliveryNoteType === 'signedSiteReceipt') && (
                      <div style={{ fontSize: '12px' }}>Select items to Attach Signed Delivery Note to:</div>
                    )}
                    {selectedDeliveryNoteType === 'deliveryNoteCorrisonProtection' && (
                      <div style={{ fontWeight: '600', fontSize: '12px' }}>Corrosion Protection / Delivery to Workshop</div>
                    )}
                    {selectedDeliveryNoteType === 'qcRelease' && (
                      <div style={{ fontWeight: '600', fontSize: '12px' }}>QC Release</div>
                    )}
                    {selectedDeliveryNoteType === 'deliveryToSite' && (
                      <div style={{ fontWeight: '600', fontSize: '12px' }}>Delivery to Site</div>
                    )}
                    {selectedDeliveryNoteType === 'signedDeliveryNoteCorrisonProtection' && (
                      <div style={{ fontWeight: '600', fontSize: '12px' }}>Signed Corrosion Protection / Delivery to Workshop</div>
                    )}
                    {selectedDeliveryNoteType === 'signedDeliveryToSite' && (
                      <div style={{ fontWeight: '600', fontSize: '12px' }}>Signed Delivery to Site</div>
                    )}
                    {selectedDeliveryNoteType === 'signedSiteReceipt' && (
                      <div style={{ fontWeight: '600', fontSize: '12px' }}>Signed Site Receipt</div>
                    )}
                    {selectedDeliveryNoteType === 'batchUpdateGrv' && (
                      <div style={{ fontSize: '12px' }}>Select Items to add GRV # to:</div>
                    )}
                    {selectedDeliveryNoteType === 'batchUpdateGrv' && (
                      <div style={{ fontWeight: '600', fontSize: '12px' }}>Site Receipt</div>
                    )}
                  </div>
                  {selectedDeliveryNoteType && (
                  <div style={{ fontWeight: '600', fontSize: '12px', textAlign: 'center', marginRight: '5px' }}>
                    Selected:
                    <div style={{ fontWeight: '700', fontSize: '12px' }}>{selectedItemsCount}</div>
                  </div>
                  )}
                  {mcPermissions?.delivery_notes?.generate && (
                    <>
                    {(selectedDeliveryNoteType === 'deliveryNoteCorrisonProtection' || 
                      selectedDeliveryNoteType === 'qcRelease' || 
                      selectedDeliveryNoteType === 'deliveryToSite') && (
                      <Button 
                        className="add-delivery-note-btn" 
                        style={{ 
                          border: '1px solid #ff6b35', 
                          color: '#ff6b35', 
                          background: 'white' 
                        }}
                        onClick={() => {
                          // Check if any items have been selected
                          const hasSelectedItems = Object.keys(selectedItems).length > 0;
                          
                          if (!hasSelectedItems) {
                            message.warning('Please select at least one item by using the + button');
                            return;
                          }
                          
                          // Check if any items are selected across all material types
                          let hasSelectedItemsInGroups = false;
                          let totalItemsSelected = 0;
                          
                          Object.keys(selectedItems).forEach(materialType => {
                            if (selectedItems[materialType].items) {
                              const itemsInGroup = Object.keys(selectedItems[materialType].items).length;
                              if (itemsInGroup > 0) {
                                hasSelectedItemsInGroups = true;
                                totalItemsSelected += itemsInGroup;
                              }
                            }
                          });
                          
                          if (!hasSelectedItemsInGroups) {
                            message.warning('Please select at least one item by using the + button');
                            return;
                          }
                          
                          // Check if any items with plus button clicked have been selected
                          let hasPlusButtonItems = false;
                          
                          Object.keys(selectedItems).forEach(materialType => {
                            if (selectedItems[materialType].items) {
                              Object.keys(selectedItems[materialType].items).forEach(itemId => {
                                if (plusButtonClicked[itemId] && selectedItems[materialType].items[itemId].qty > 0) {
                                  hasPlusButtonItems = true;
                                }
                              });
                            }
                          });

                          if (!hasPlusButtonItems) {
                            message.warning('Please use the + button to select items for the delivery note');
                            return;
                          }
                          
                          // Open the delivery note popup
                          setIsDeliveryNotePopupVisible(true);
                        }}
                        disabled={selectedItemsCount === 0}
                      >
                        Add to Delivery Note
                      </Button>
                    )}
                    {(selectedDeliveryNoteType === 'signedDeliveryNoteCorrisonProtection' || 
                      selectedDeliveryNoteType === 'signedDeliveryToSite' || 
                      selectedDeliveryNoteType === 'signedSiteReceipt') && (
                      <Button 
                        className="add-ssign-delivery-note-btn" 
                        style={{ 
                          minWidth: '200px',
                          border: '1px solid #ff6b35', 
                          color: '#ff6b35', 
                          background: 'white' 
                        }}
                        onClick={() => {
                          // Check if any items have been selected
                          const hasSelectedItems = Object.keys(selectedItems).length > 0;
                          
                          if (!hasSelectedItems) {
                            message.warning('Please select at least one item by using the + button');
                            return;
                          }
                          
                          // Check if any items are selected across all material types
                          let hasSelectedItemsInGroups = false;
                          let totalItemsSelected = 0;
                          
                          Object.keys(selectedItems).forEach(materialType => {
                            if (selectedItems[materialType].items) {
                              const itemsInGroup = Object.keys(selectedItems[materialType].items).length;
                              if (itemsInGroup > 0) {
                                hasSelectedItemsInGroups = true;
                                totalItemsSelected += itemsInGroup;
                              }
                            }
                          });
                          
                          if (!hasSelectedItemsInGroups) {
                            message.warning('Please select at least one item by using the + button');
                            return;
                          }
                          
                          // Check if any items with plus button clicked have been selected
                          let hasPlusButtonItems = false;
                          
                          Object.keys(selectedItems).forEach(materialType => {
                            if (selectedItems[materialType].items) {
                              Object.keys(selectedItems[materialType].items).forEach(itemId => {
                                if (plusButtonClicked[itemId] && selectedItems[materialType].items[itemId].qty > 0) {
                                  hasPlusButtonItems = true;
                                }
                              });
                            }
                          });

                          if (!hasPlusButtonItems) {
                            message.warning('Please use the + button to select items for signing the delivery note');
                            return;
                          }
                          
                          // Handle signed delivery note functionality
                          setIsSignedDeliveryNotePopupVisible(true);
                        }}
                        disabled={selectedItemsCount === 0}
                      >
                        Add Signed Delivery Note
                      </Button>
                    )}
                    {selectedDeliveryNoteType === 'batchUpdateGrv' && (
                      <Button 
                        className="add-grv-btn" 
                        style={{ 
                          border: '1px solid #ff6b35', 
                          color: '#ff6b35', 
                          background: 'white' 
                        }}
                        onClick={() => {
                          // Check if any items have been selected
                          const hasSelectedItems = Object.keys(selectedItems).length > 0;
                          
                          if (!hasSelectedItems) {
                            message.warning('Please select at least one item by using the + button');
                            return;
                          }
                          
                          // Check if any items are selected across all material types
                          let hasSelectedItemsInGroups = false;
                          let totalItemsSelected = 0;
                          
                          Object.keys(selectedItems).forEach(materialType => {
                            if (selectedItems[materialType].items) {
                              const itemsInGroup = Object.keys(selectedItems[materialType].items).length;
                              if (itemsInGroup > 0) {
                                hasSelectedItemsInGroups = true;
                                totalItemsSelected += itemsInGroup;
                              }
                            }
                          });
                          
                          if (!hasSelectedItemsInGroups) {
                            message.warning('Please select at least one item by using the + button');
                            return;
                          }
                          
                          // Check if any items with plus button clicked have been selected
                          let hasPlusButtonItems = false;
                          
                          Object.keys(selectedItems).forEach(materialType => {
                            if (selectedItems[materialType].items) {
                              Object.keys(selectedItems[materialType].items).forEach(itemId => {
                                if (plusButtonClicked[itemId] && selectedItems[materialType].items[itemId].qty > 0) {
                                  hasPlusButtonItems = true;
                                }
                              });
                            }
                          });

                          if (!hasPlusButtonItems) {
                            message.warning('Please use the + button to select items for GRV update');
                            return;
                          }
                          
                          setIsGrvPopupVisible(true);
                        }}
                        disabled={selectedItemsCount === 0}
                      >
                        Add GRV #
                      </Button>
                    )}
                      <DeliveryNote
                        debounce={debouncedDefaultPageOneCallApi}
                        project_id={project_id}
                        onTypeChange={setSelectedDeliveryNoteType}
                        mcPermissions={mcPermissions}
                      />
                      <AddToDeliveryNotePopup
                        visible={isDeliveryNotePopupVisible}
                        onClose={() => setIsDeliveryNotePopupVisible(false)}
                        project_id={project_id}
                        selectedItems={selectedItems}
                      />
                      <AddToSignedDeliveryNotePopup
                        visible={isSignedDeliveryNotePopupVisible}
                        onClose={() => setIsSignedDeliveryNotePopupVisible(false)}
                        project_id={project_id}
                        selectedItems={selectedItems}
                        selectedDeliveryNoteType={selectedDeliveryNoteType}
                      />
                      <AddToGrvPopup
                        visible={isGrvPopupVisible}
                        onClose={() => setIsGrvPopupVisible(false)}
                        project_id={project_id}
                        selectedItems={selectedItems}
                        selectedDeliveryNoteType={selectedDeliveryNoteType}
                      />
                    </>
                  )}       
                  <Tooltip text="Filter">
                    <FilterIcon className="orange-icon" onClick={() => setShowFilter(!showFilter)} />
                  </Tooltip>
                  {mcPermissions?.general?.export && <Tooltip text="Export">
                    <ExportDoc project_id={project_id} allMaterialControl={
                      Object.keys(search).some(key => {
                        return search[key] !== null && search[key] !== undefined && search[key] !== '' && 
                               (!Array.isArray(search[key]) || search[key].length > 0);
                      }) || Object.keys(filter).length > 0 ? allMaterialControl : []
                    }/>
                  </Tooltip>}
                  {mcPermissions?.general?.import && <Tooltip text="Import">
                    <ImportDoc
                      debounce={debouncedDefaultPageOneCallApi}
                      project_id={project_id}
                    />
                  </Tooltip>}
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>

      <FilterAndBatchUpdate
        handleCloseFilter={handleCloseFilterSection}
        handleFilter={handleFilter}
        handleBatchUpdate={handleBatchUpdate}
        handleCloseBatch={handleCloseBatchSection}
        loading={fetchDocsLoading}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        showBatch={showBatch}
        setShowBatch={setShowBatch}
        project_id={project_id}
      />

      <Col span={24}>
        <div style={{ position: 'relative' }}>
          <div id="api-queue-overlay" style={{ display: 'none', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10, background: 'rgba(255,255,255,0.5)', alignItems: 'center', justifyContent: 'center' }}>
            <Spin />
          </div>
        <Form form={form} component={false} onFinish={handleFinish}>
          <Table
            scroll={{ x: 'max-content' }}
            className={`special-table ims-doc-table ${
              shouldAddBtnDisable() ? "doc-table-is-exapnded" : ""
            }`}
            components={{
              body: {
                cell: (props) => (
                  <EditableCell
                    cell={props}
                    expandedRowKeys={expandedRowKeys}
                    setExpandedRowKeys={setExpandedRowKeys}
                    images={images}
                    setImages={setImages}
                    attachPopupVisible={attachPopupVisible}
                    setAttachPopupVisible={setAttachPopupVisible}
                    currentUpdateObj={currentUpdateObj}
                    values={form.getFieldsValue()}
                    setFields={setFields}
                    fields={fields}
                    handleChangeDocType={handleChangeDocType}
                    getColumnName={getColumnName}
                    isRevisionUpdateCase={isRevisionUpdateCase}
                    dueDateRequired={dueDateRequired}
                    type={addType && addType.toLowerCase()}
                  />
                ),
              },
            }}
            expandable={{
              expandedRowRender,
              expandIcon: null,
              showExpandColumn: false,
              expandedRowKeys: expandedRowKeys,
              rowExpandable: ({ id }) => expandedRowKeys.includes(id),
            }}
            onRow={({ id }) =>
              expandedRowKeys.includes(id) && {
                className: `expand-doc-parent ${
                  isRevisionUpdateCase ? "ims-doc-readonly-input" : ""
                }`,
              }
            }
            rowKey={(record) => record.id}
            loading={!suppressTableLoader && (fetchDocsLoading || fetchUtilsLoading)}
            rowClassName="editable-row"
            dataSource={data}
            columns={mergedColumns}
            onChange={handleChange}
            pagination={false}
          />
        </Form>
        </div>
      </Col>
      <Col span={24}>
        <CustomPagination
          page={page}
          setPage={setPage}
          resultPerPage={resultPerPage}
          setResultPerPage={setResultPerPage}
          debouncedCallApi={debouncedCallApi}
          totalRecord={totalRecords}
        />
      </Col>
    </Row>
  );
};

export default DistributionTable;
